import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import {toast} from "react-toastify";
import {ICatalog, IGetCatalogsResponse, IGetNotesResponse, IProductInsights} from "../models/Catalog";
import {
    IColumns, ICreateSubOrganizationRequest, ICustomColumnSet,
    IGetPermissionsResponse,
    ISubOrganization,
    IUserSettings,
    IUserSettingsUpdateRequest,
    IVendorSettings,
    IKnownVendor
} from "../models/Settings";
import {RootState} from "./rootReducer";
import {IActionResponse, IUploadFileResponse} from "../dal/BaseDAL";
import {
    IWorkspace, IWorkspaceExtensionMetadata, IWorkspaceFileImportRequest, IWorkspaceFileImportResponse,
    IWorkspaceItem,
    IWorkspaceMetadata,
    IWorkspacePatchRequest, IWorkspaceReference, IProductSuggestion} from "../models/Workspace";
import {ExtensionType, SEARCHCOLUMNS, WORKSPACECOLUMNS} from "../Constants";
import {IColumn} from "@fluentui/react";
import {
    ICountResponse,
    IFavoriteLookup, IMetadata, INewProduct,
    IProduct, IProductTagsResponse,
    IQuickSearchResponse,
    ISearchQueryResponse,
    ISearchRequest,
    ISearchSuggestions,
} from "../models/Search";
import {INormalizedProduct} from "../models/NormalizedProduct";
import {IProductLinkedItem, IProductLinkedItemEntry} from "../models/LinkedItems";
import {IBulkStorefrontListingRequest, IBulkStorefrontListingResponse} from "../models/BulkStorefront";
import {setSelectedWorkspaceId} from "./settingsSlice";
import {
    ICreateCsvRequest,
    IDirectImportExtensionPreviewRequest,
    IDirectImportExtensionPreviewResponse,
    IDirectImportExtensionRequest,
    IDirectImportExtensionResponse,
    IExtension,
    ICrmFolioCandidate,
    ICrmFolioCapabilitiesRequest,
    ICrmTestOpportunityResponse,
    IPsaProposalDecisionRequest,
    IPsaProvisioningProposal,
    IExtensionFile,
    IExtensionFolioSubextensionReference,
    IExtensionInstallRequest,
    IExtensionLog,
    IExtensionActivity,
    IExtensionFieldMetadataResponse,
    IExtensionOptionsResponse,
    IExtensionPotentialMatchResponse,
    IExtensionResponse,
    IFolioValidationRequest,
    IGetExtensionFieldsResponse,
    IImportExtensionMappingSampleRequest,
    IImportExtensionMappingSampleResponse,
    IInstalledExtension,
    IInstalledExtensionFolio,
    ILookupConditions,
    IProductReference,
    IRealTimeExtensionResponse,
    IRecommendationResponse,
    IReportStatusLog,
    IPurchaseHistoryItem,
    ISavedExtensionField,
    IUnmatchedExtensionProduct, IValidateExtensionResponse
} from "../models/Extension";
import {ArrayBufferToBase64} from "../logic/ArrayBufferConverter";
import {cloneDeep} from "lodash";
import {NormalizeResult, updateProductFromRealtime, updateWorkspaceItemFromRealtime} from "../logic/Product";
import {criteriaIsBlank} from "../logic/Search";
import {ICollectionResponse} from "../models/ICollectionResponse";
import {IAdaptiveCatalogTask} from "../models/Tasks";
import {
    IApiKey,
    IGenerateApiKeyRequest,
    IGenerateApiKeyResponse,
    IGetApiKeysResponse,
    IGetSessionKeyRequest, IKeyAuthTypesResponse,
    ISupportLoginExchangeRequest, ISupportLoginExchangeResponse, ISupportSessionNotes, ISupportSessionStatus
} from "../models/ApiKey";
import {verifySupportSession} from "../logic/supportSession";
import {IApiUsageMonthlyReport, ISearchReport} from "../models/Reporting";
import {setSearchSession} from "./authSlice";
import {updateSearchId} from "./searchSlice";
import {IGetTaxCodeResponse, ITaxCode} from "../models/TaxCode";
import {ICompany, ICompanyResponse, ICompanySuggestion, IContact, ILocation} from "../models/Company";
import {
    ICustomerRequestAnalysisOverview,
    ICustomerRequestAnalysisRequest,
    ICustomerRequestAnalysisResponse,
    IUserChat,
    IUserChatMessageRequest
} from "../models/MachineLearning";

const ORGANIZATION_TYPE = 'Organizations';
export const LIST = 'LIST';
/**
 * Cache id for the storefront AI-generation list. Separate from LIST so an ordinary storefront save
 * does not refetch it, and so the four assistant calls that DO change it can invalidate it by name.
 */
export const AI_GENERATION = 'AI_GENERATION';
export const CATALOG_TYPE = 'Catalogs';
const TAX_CODE_TYPE = 'TaxCodes';
export const COLUMNS_TYPE = 'Columns';
export const WEBHOOK_TYPE_TAG = 'Webhooks';
export const WORKSPACES_TYPE = 'Workspaces';
const WORKSPACE_TEMPLATES_TYPE = 'WorkspaceTemplates';
export const WORKSPACE_PRODUCTS_TYPE = 'WorkspaceProducts';
const WORKSPACE_METADATA_TYPE = 'WorkspaceMetadata';
const WORKSPACE_RECOMMENDATIONS_TYPE = 'WorkspaceRecommendations';
const COMPANY_TYPE = 'Companies';
const EXTENSION_COMPANY_TYPE = 'ExtensionCompanies';
const COMPANY_COUNT_TYPE = 'CompanyCount';
const CONTACT_TYPE = 'Contacts';
const LOCATION_TYPE = 'Locations';
export const FAVORITES_TYPE = 'Favorites';
export const SEARCH_RESULTS_TYPE = 'SearchResults';
const INSTALLED_EXTENSION_TYPE = 'InstalledExtensions';
const INSTALLED_EXTENSION_LOGS_TYPE = 'InstalledExtensionLogs';
const EXTENSION_ACTIVITIES_TYPE = 'ExtensionActivities';
const EXTENSION_LIBRARY_TYPE = 'ExtensionLibrary';
const EXTENSION_UNMATCHED_PRODUCT_TYPE = 'ExtensionUnmatchedProducts';
const PROCUREMENT_UNORDERED_PRODUCT_TYPE = 'ProcurementUnorderedProducts';
const PROCUREMENT_ORDER_REQUIREMENTS_TYPE = 'ProcurementOrderRequirements'
const EXTENSION_TYPE = 'Extensions';
const ITEM_EXTENSION_FIELD_TYPE = 'ItemExtensionFields';
const EXTENSION_LINK_TYPE = 'ExtensionLinks';
const EXTENSION_POSSIBLE_MATCH = 'ExtensionPossibleMatches'
const PRODUCT_NOTES_TYPE = 'ProductNotes';
const ITEM_DETAILS_TYPE = 'ItemDetails';
const TASKS_TYPE = 'Tasks';
const API_KEYS = 'ApiKeys'
const SUB_ORGANIZATIONS = 'SubOrganizations';
const ORDER_CARRIER_OPTIONS_TYPE = 'CarrierOptions';
const ORDER_WAREHOUSE_OPTIONS_TYPE = 'WarehouseOptions';
const IS_FREIGHT_VENDOR_TYPE = "IsFreightVendor"
const ORDER_PROCUREMENT_ITEMS_TYPE = "OrderProcurementItems"
const ORDER_FULFILLMENTS_TYPE = "OrderFulfillments"
const ORDER_EVENTS_TYPE = "OrderEvents"
const EXTENSION_ID_BY_SOURCE_TYPE = "ExtensionId";
const PROCUREMENT_SOURCE_VENDORS = "ProcurementSourceVendors";
export const PAYMENT_PROCESSOR_SETUP_DETAILS = "PaymentProcessorSetupDetails";
export const STOREFRONT_ORDERS = "StorefrontOrders";
export const STOREFRONT_CARTS = "StorefrontCarts";
export const STOREFRONT_SETTINGS = "StorefrontSettings";
export const STOREFRONT_SECTIONS = "StorefrontSections";
export const STOREFRONT_USERS = "StorefrontUsers";
export const STOREFRONT_PAGES = "StorefrontPages";
export const STOREFRONT_BANNERS = "StorefrontBanners";
// The header/footer link menus. They are separate Cosmos documents, staged and published like
// sections, so publish and revert replace them and their queries have to be invalidated.
export const STOREFRONT_LINKS = "StorefrontLinks";
export const STOREFRONT_STYLES = "StorefrontStyles";
export const STOREFRONT_ASSETS = "StorefrontAssets";
export const EXTENSION_FOLIO_TYPE = "ExtensionFolio";
export const FOLIO_CATALOG_TYPE = "FolioCatalog";
export const DISTRIBUTOR_CANDIDATES_TYPE = "DistributorCandidates";
const PSA_PROPOSAL_TYPE = "PsaProposal";
const ML_USER_CHAT_TYPE = "MLUserChat";
export const STOREFRONT_CUSTOM_THEMES = "StorefrontCustomThemes";
export const CUSTOM_DOMAINS_TYPE = "CustomDomains";
export const ORGANIZATION_ENTITLEMENTS_TYPE = "OrganizationEntitlements";
export const STOREFRONT_TEMPLATES_TYPE = "StorefrontTemplates";
const SETTINGS_VENDOR_SETTINGS = "VendorSettings";
const KNOWN_VENDORS = "KnownVendors";
const PRODUCT_BUNDLE_TYPE = "ProductBundles";
const PRODUCT_BUNDLE_ITEMS_TYPE = "ProductBundleItems";
export const PRODUCT_BUNDLE_REFS_TYPE = "ProductBundleRefs";
export const BUNDLE_SUGGESTIONS_TYPE = "BundleSuggestions";
const PREPARED_CART_DELIVERY_EMAIL_BODY = "PreparedCartEmailBody"
export const DASHBOARD_TYPE = 'Dashboards';
export const WIDGET_DATA_TYPE = 'WidgetData';
export const AVAILABLE_WIDGETS_TYPE = 'AvailableWidgets';
export const SMTP_SETTINGS_TYPE = 'SmtpSettings';
export const EMAIL_LOG_TYPE = 'EmailLog';
export const CSV_IMPORT_ACTIVITY_TYPE = 'CsvImportActivity';
export const PROMOTIONS_TYPE = 'Promotions';
const PRODUCT_LINKED_ITEMS_TYPE = 'ProductLinkedItems';
const LINKED_ITEM_TYPES_TYPE = 'LinkedItemTypes';
export const ASSISTANT_SESSIONS_TYPE = 'AssistantSessions';
export const ASSISTANT_USAGE_TYPE = 'AssistantUsage';
export const GETTING_STARTED_TYPE = 'GettingStarted';
export const INTEGRATION_HEALTH_TYPE = 'IntegrationHealth';

import {pca} from '../index';
import {redirectIfInteractionRequired} from "../logic/authRedirect";
import {loginRequest} from "../authConfig";
import { ISearchDataRequest } from "../models/SearchData";
import {INotification} from "../models/Notification";
import {
    IGridAssignmentResponse,
    IGridConfiguration,
    IGridSampleData
} from "../models/GridConfiguration";
import { IUserTour } from "../models/Tours";
import {getQueryStringFromConditions} from "../logic/StringHelper";
import { IFeatureRequest } from "../models/FeatureRequests";
import { IConfigurationProduct, IConfigurationResolutionRequest, IConfigurationResolutionResponse, IConfiguratorProductSearchView } from "../models/Configurator";

// A support tab whose session was ended elsewhere (or expired) gets 401s from then on; without this it would carry on
// showing whatever it had loaded. verifySupportSession confirms before ending anything, since some routes answer 401
// for a missing permission. The exchange itself is excluded: a refused code is reported on its own page.
const supportAwareBaseQuery = (base: ReturnType<typeof fetchBaseQuery>): ReturnType<typeof fetchBaseQuery> =>
    async (args, api, extraOptions) => {
        const result = await base(args, api, extraOptions);
        // FETCH_ERROR too: an API whose 401s lack CORS headers surfaces them as network failures. The check itself
        // only ends the session on a 401 it can read, so a genuine network blip changes nothing.
        const status = result.error?.status;
        if ((status === 401 || status === 'FETCH_ERROR') && api.endpoint !== 'exchangeSupportLogin') verifySupportSession();
        return result;
    };

const api = createApi({
    reducerPath: 'api',
    baseQuery: supportAwareBaseQuery(fetchBaseQuery({
        baseUrl: `${window.config.baseUrl}/api/`,
        prepareHeaders: async (headers, api) => {
            if (api.endpoint == "getSessionKey") return headers;
            // Trades a one-time code for a session, so there is no credential to send yet.
            if (api.endpoint == "exchangeSupportLogin") {
                if (window.config.apiVersion)
                    headers.append('x-api-version', window.config.apiVersion.toString());
                return headers;
            }
            const state = api.getState() as RootState;
            headers.append('Content-Type', 'application/json');
            if (state.auth.sessionKey)
                headers.append('x-session-key', state.auth.sessionKey);
            else if (state.auth.accessToken) {
                const account = pca.getAllAccounts()[0];
                if (account) {
                    const tokenRequest = {
                        scopes: loginRequest.scopes,
                        account: account,
                    };
                    try {
                        const response = await pca.acquireTokenSilent(tokenRequest);
                        headers.append('Authorization', `Bearer ${response.accessToken}`);
                    } catch (error) {
                        console.log(error);
                        // A renewal that needs the user won't succeed on retry: send them to sign in again once,
                        // rather than failing every request until they reload.
                        redirectIfInteractionRequired(pca, tokenRequest, error);
                        throw new Error("Not authenticated");
                    }
                } else {
                    headers.append('Authorization', `Bearer ${state.auth.accessToken}`);
                }
            } else {
                throw new Error("Not authenticated");
            }
            if (state.settings.selectedOrganization)
                headers.append('x-organization', state.settings.selectedOrganization);
            // Sub-organization (customer) scope. The API validates it against the selected org and
            // narrows extensions, installs and vendor pricing to that customer.
            if (state.settings.selectedSubOrganization)
                headers.append('x-suborganization', state.settings.selectedSubOrganization);
            if (state.auth.searchSession)
                headers.append('x-search-session', state.auth.searchSession)
            if (state.search.searchId)
                headers.append('x-search-id', state.search.searchId)
            if (window.config.apiVersion)
                headers.append('x-api-version', window.config.apiVersion.toString())
            return headers;
        }
    })),
    tagTypes: [
        PROMOTIONS_TYPE,
        ORGANIZATION_TYPE,
        CATALOG_TYPE,
        TAX_CODE_TYPE,
        COLUMNS_TYPE,
        WEBHOOK_TYPE_TAG,
        WORKSPACES_TYPE,
        WORKSPACE_TEMPLATES_TYPE,
        WORKSPACE_PRODUCTS_TYPE,
        WORKSPACE_METADATA_TYPE,
        WORKSPACE_RECOMMENDATIONS_TYPE,
        COMPANY_TYPE,
        EXTENSION_COMPANY_TYPE,
        CONTACT_TYPE,
        LOCATION_TYPE,
        FAVORITES_TYPE,
        SEARCH_RESULTS_TYPE,
        EXTENSION_TYPE,
        INSTALLED_EXTENSION_TYPE,
        INSTALLED_EXTENSION_LOGS_TYPE,
        EXTENSION_ACTIVITIES_TYPE,
        EXTENSION_LIBRARY_TYPE,
        ITEM_EXTENSION_FIELD_TYPE,
        EXTENSION_LINK_TYPE,
        EXTENSION_POSSIBLE_MATCH,
        PRODUCT_NOTES_TYPE,
        ITEM_DETAILS_TYPE,
        TASKS_TYPE,
        API_KEYS,
        EXTENSION_UNMATCHED_PRODUCT_TYPE,
        SUB_ORGANIZATIONS,
        COMPANY_COUNT_TYPE,
        PROCUREMENT_UNORDERED_PRODUCT_TYPE,
        PROCUREMENT_ORDER_REQUIREMENTS_TYPE,
        ORDER_CARRIER_OPTIONS_TYPE,
        ORDER_WAREHOUSE_OPTIONS_TYPE,
        IS_FREIGHT_VENDOR_TYPE,
        ORDER_PROCUREMENT_ITEMS_TYPE,
        ORDER_FULFILLMENTS_TYPE,
        ORDER_EVENTS_TYPE,
        EXTENSION_ID_BY_SOURCE_TYPE,
        PROCUREMENT_SOURCE_VENDORS,
        PAYMENT_PROCESSOR_SETUP_DETAILS,
        STOREFRONT_ORDERS,
        STOREFRONT_CARTS,
        STOREFRONT_SETTINGS,
        STOREFRONT_SECTIONS,
        STOREFRONT_USERS,
        STOREFRONT_PAGES,
        STOREFRONT_STYLES,
        STOREFRONT_ASSETS,
        EXTENSION_FOLIO_TYPE,
        FOLIO_CATALOG_TYPE,
        DISTRIBUTOR_CANDIDATES_TYPE,
        PSA_PROPOSAL_TYPE,
        ML_USER_CHAT_TYPE,
        STOREFRONT_CUSTOM_THEMES,
        CUSTOM_DOMAINS_TYPE,
        ORGANIZATION_ENTITLEMENTS_TYPE,
        STOREFRONT_TEMPLATES_TYPE,
        SETTINGS_VENDOR_SETTINGS,
        KNOWN_VENDORS,
        PRODUCT_BUNDLE_TYPE,
        PRODUCT_BUNDLE_ITEMS_TYPE,
        PRODUCT_BUNDLE_REFS_TYPE,
        BUNDLE_SUGGESTIONS_TYPE,
        PREPARED_CART_DELIVERY_EMAIL_BODY,
        DASHBOARD_TYPE,
        WIDGET_DATA_TYPE,
        AVAILABLE_WIDGETS_TYPE,
        SMTP_SETTINGS_TYPE,
        EMAIL_LOG_TYPE,
        CSV_IMPORT_ACTIVITY_TYPE,
        PRODUCT_LINKED_ITEMS_TYPE,
        LINKED_ITEM_TYPES_TYPE,
        STOREFRONT_BANNERS,
        STOREFRONT_LINKS,
        ASSISTANT_SESSIONS_TYPE,
        ASSISTANT_USAGE_TYPE,
        GETTING_STARTED_TYPE,
        INTEGRATION_HEALTH_TYPE,
    ],
    endpoints: (build) => ({
        //region CATALOGS
        getCatalogs: build.query<ICatalog[], void>({
            query: () => ({
                url: 'catalog?',
            }),
            transformResponse: (response: IGetCatalogsResponse) => response.catalogs,
            providesTags: (result) =>
                result
                    ? [
                        ...result.map(c => ({type: CATALOG_TYPE, id: c.name} as const)),
                        {type: CATALOG_TYPE, id: LIST},
                    ]
                    : [{type: CATALOG_TYPE, id: LIST}],
        }),
        addCatalog: build.mutation<IActionResponse, ICatalog>({
            query: (catalog: ICatalog) => ({
                url: 'catalog',
                method: 'POST',
                body: catalog,
            }),
            invalidatesTags: [{type: CATALOG_TYPE, id: LIST}],
        }),
        deleteCatalog: build.mutation<IActionResponse, string>({
            query: (arg) => ({
                url: `catalog/${arg}`,
                method: 'DELETE'
            }),
            invalidatesTags: (_result, _error, arg) => [{type: CATALOG_TYPE, id: arg}],
        }),
        updateCatalog: build.mutation<IActionResponse, ICatalog>({
            query: (catalog: ICatalog) => ({
                url: 'catalog',
                method: 'PUT',
                body: catalog,
            }),
            invalidatesTags: [{type: CATALOG_TYPE, id: LIST}],
        }),
        //endregion
        //region Tax Codes
        getTaxCodes: build.query<ITaxCode[], void>({
            query: () => ({
                url: 'settings/taxCodes?',
            }),
            transformResponse: (response: IGetTaxCodeResponse) => response.taxCodes,
            providesTags: (result) =>
                result
                    ? [
                        ...result.map(c => ({type: TAX_CODE_TYPE, id: c.name} as const)),
                        {type: TAX_CODE_TYPE, id: LIST},
                    ]
                    : [{type: TAX_CODE_TYPE, id: LIST}],
        }),
        addUpdateTaxCode: build.mutation<IActionResponse, ITaxCode>({
            query: (taxCode: ITaxCode) => ({
                url: `settings/taxCodes`,
                method: 'PUT',
                body: taxCode
            }),
            async onQueryStarted(arg, {dispatch, queryFulfilled}) {
                const finishedData = await queryFulfilled
                dispatch(
                    api.util.updateQueryData('getTaxCodes', undefined , (draft) => {
                        const codes = cloneDeep(draft);
                        const index = codes.findIndex(a => a.name == arg.name)
                        if(index > -1 && finishedData.data != undefined){
                            codes[index] = arg
                            codes[index].id = finishedData.data.id
                        }
                        else {
                            if(finishedData.data != undefined){
                                arg.id = finishedData.data.id
                                codes.push(arg)
                            }
                        }
                        Object.assign(draft, codes);
                    })
                )
            }
        }),
        deleteTaxCode: build.mutation<IActionResponse, string>({
            query: (arg) => ({
                url: `settings/taxCodes/${arg}`,
                method: 'DELETE'
            }),
            async onQueryStarted(arg, {dispatch, queryFulfilled}) {
                const finishedData = await queryFulfilled
                dispatch(
                    api.util.updateQueryData('getTaxCodes', undefined , (draft) => {
                        const index = draft.findIndex(a => a.id == arg)
                        if(index > -1 && finishedData.data != undefined){
                            draft.splice(index, 1)
                        }

                    })
                );
            }

        }),

        //endregion
        
        //region CUSTOMIZABLE COLUMNS
        getColumns: build.query<IColumns, void>({
            query: () => 'settings/columns?',
            providesTags: [COLUMNS_TYPE],
            transformResponse: (response: IColumns) => ({
                searchColumns: response.searchColumns != null && response.searchColumns.length > 0 ? response.searchColumns : SEARCHCOLUMNS,
                workspaceColumns: response.workspaceColumns != null && response.workspaceColumns.length > 0 ? response.workspaceColumns : WORKSPACECOLUMNS,
            }),
        }),
        setSearchColumns: build.mutation<IActionResponse, IColumn[]>({
            query: (columns: IColumn[]) => {
                const cols = columns.map(i => i.key);
                return {
                    url: '/settings/columns/search',
                    method: 'POST',
                    body: cols
                }
            },
            invalidatesTags: [COLUMNS_TYPE],
            onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
                const patchResult = dispatch(
                    api.util.updateQueryData('getColumns', undefined, (draft) => {
                        draft.searchColumns = arg.map(i => i.key);
                    })
                );

                try {
                    await queryFulfilled;
                } catch (error) {
                    patchResult.undo();
                    console.log(error);
                }
            }
        }),
        setWorkspaceColumns: build.mutation<IActionResponse, IColumn[]>({
            query: (columns: IColumn[]) => {
                const cols = columns.map(i => i.key);
                return {
                    url: '/settings/columns/workspace',
                    method: 'POST',
                    body: cols
                }
            },
            invalidatesTags: [COLUMNS_TYPE],
            onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
                const patchResult = dispatch(
                    api.util.updateQueryData('getColumns', undefined, (draft) => {
                        draft.workspaceColumns = arg.map(i => i.key);
                    })
                );

                try {
                    await queryFulfilled;
                } catch (error) {
                    patchResult.undo();
                    console.log(error);
                }
            }
        }),
        //endregion

        //region WORKSPACES
        getWorkspaces: build.query<IWorkspace[], { filter?: string, searchText?: string, conditions?: ILookupConditions }>({
            query: (arg) => `workspaces/summary` + getQueryStringFromConditions(arg.conditions, [].appendIfDefined(arg.filter, `filter=${arg.filter}`).appendIfDefined(arg.searchText, `searchText=${arg.searchText}`)),
            transformResponse: (response: ICollectionResponse<IWorkspace>) => response.items,
            serializeQueryArgs: ({endpointName}) => {
                return endpointName
            },
            // Refetch when the page arg changes
            forceRefetch({ currentArg, previousArg }) {
                return currentArg !== previousArg
            },
            providesTags: (results) => results
                ? [...results.map(w => ({type: WORKSPACES_TYPE, id: w.id} as const)), {type: WORKSPACES_TYPE, id: LIST}]
                : [{type: WORKSPACES_TYPE, id: LIST}]
        }),
        getWorkspaceSearchViews: build.query<ICollectionResponse<IWorkspace>, { filter?: string, searchText?: string, conditions?: ILookupConditions }>({
            query: (arg) => `workspaces/summary` + getQueryStringFromConditions(arg.conditions, [].appendIfDefined(arg.filter, `filter=${arg.filter}`)
                .appendIfDefined(arg.searchText, `searchText=${arg.searchText}`)),
            serializeQueryArgs: ({endpointName}) => {
                return endpointName
            },
            // Refetch when the page arg changes
            forceRefetch({ currentArg, previousArg }) {
                return currentArg !== previousArg
            },
            providesTags: (results) => results
                ? [...results.items.map(w => ({type: WORKSPACES_TYPE, id: w.id} as const)), {type: WORKSPACES_TYPE, id: LIST}]
                : [{type: WORKSPACES_TYPE, id: LIST}]
        }),
        getTemplateWorkspaces: build.query<IWorkspace[], void>({
            query: () => 'workspaces/templates',
            transformResponse: (response: ICollectionResponse<IWorkspace>) => response.items,
            providesTags: (results) => results
                ? [...results.map(w => ({type: WORKSPACE_TEMPLATES_TYPE, id: w.id} as const)), {type: WORKSPACE_TEMPLATES_TYPE, id: LIST}]
                : [{type: WORKSPACE_TEMPLATES_TYPE, id: LIST}]
        }),
        getRecentWorkspaceRefs: build.query<IWorkspaceReference[], void>({
            query: () => 'workspaces/recent',
            transformResponse: (response: ICollectionResponse<IWorkspaceReference>) => response.items,

        }),
        // Name search across all workspaces, for pickers that need to reach past the five recents.
        // Deliberately keyed per-arg: getWorkspaces / getWorkspaceSearchViews both collapse every
        // arg into a single cache entry (serializeQueryArgs -> endpointName), so sharing one of
        // those would have a picker and the workspace search grid overwriting each other's results.
        searchWorkspaceRefs: build.query<IWorkspaceReference[], { searchText: string, filter?: string, pageSize?: number }>({
            query: (arg) => `workspaces/summary` + getQueryStringFromConditions(
                {page: 1, pageSize: arg.pageSize ?? 25},
                [`filter=${arg.filter ?? 'All'}`, `searchText=${encodeURIComponent(arg.searchText)}`]
            ),
            transformResponse: (response: ICollectionResponse<IWorkspace>) =>
                response.items.map(w => ({id: w.id, name: w.name, active: true})),
            providesTags: [{type: WORKSPACES_TYPE, id: LIST}],
        }),
        getWorkspace: build.query<IWorkspace, string >({
            query: (arg) => `workspaces/${arg}`,
            providesTags: (results) => results
                ? [{type: WORKSPACES_TYPE, id: results.id}]
                : [],

            async onQueryStarted(arg, {dispatch, queryFulfilled}) {
                const finishedData = await queryFulfilled
                dispatch(
                    api.util.updateQueryData('getRecentWorkspaceRefs', undefined, (draft) => {
                        const newRef = { id: finishedData.data.id, active: true, name: finishedData.data.name, lastAccessed: new Date() };

                        if (!draft) {
                            return [newRef];
                        }

                        const index = draft.findIndex(a => a.id === finishedData.data.id);
                        if (index !== -1) {
                            draft.splice(index, 1);
                        }
                        draft.unshift(newRef);

                        if (draft.length > 5) {
                            draft.pop();
                        }
                    })
                );
            }
        }),
        addWorkspace: build.mutation<IActionResponse, string>({
            query: (arg) => ({
                url: `workspaces?name=${arg}`,
                method: 'POST'
            }),
            invalidatesTags: () => [
                {type: WORKSPACES_TYPE, id: LIST}
            ],
        }),
        addWorkspaceWithTemplateDefaults: build.mutation<IActionResponse, {name: string, template: string}>({
            query: (arg) => ({
                url: `workspaces/templates/${arg.template}/createFromTemplate/${arg.name}`,
                method: 'POST'
            }),
            invalidatesTags: () => [
                {type: WORKSPACES_TYPE, id: LIST}
            ],
        }),
        removeWorkspace: build.mutation<IActionResponse, string>({
            query: (arg) => ({
                url: `workspaces/${arg}`,
                method: 'DELETE'
            }),
            invalidatesTags: (_1, _2, arg) => [
                {type: WORKSPACES_TYPE, id: arg},
                {type: WORKSPACES_TYPE, id: LIST},
            ],
            async onQueryStarted(arg, {dispatch, queryFulfilled}) {
                const finishedData = await queryFulfilled
                dispatch(
                    api.util.updateQueryData('getRecentWorkspaceRefs', undefined, (draft) => {
                        const updatedData = cloneDeep(draft)
                        const index = draft?.findIndex(a => a.id === finishedData.data.id);

                        if (index !== -1) {
                            updatedData[index].active = false
                            Object.assign(draft, updatedData)
                        }
                    })
                );
            }
        }),
        putWorkspace: build.mutation<null, IWorkspacePatchRequest>({
            query: (arg) => ({
                url: `workspaces/${arg.id}`,
                method: 'PUT',
                body: {
                    ...arg,
                }
            }),
            invalidatesTags: (_response, _error, arg) =>  [
                {type: WORKSPACES_TYPE, id: arg.id},
            ],
            async onQueryStarted(arg, {dispatch, queryFulfilled}) {
                if (arg.id) {
                    const patchResult = dispatch(
                        api.util.updateQueryData('getWorkspace', arg.id, (draft) => {
                            Object.assign(draft, arg)
                        })
                    )
                    const recentRefResults = dispatch(
                        api.util.updateQueryData('getRecentWorkspaceRefs', undefined, (draft) => {
                            const updatedIndex = draft.findIndex(a => a.id == arg.id)
                            if(updatedIndex != -1) {
                                const updatedWorkspace = cloneDeep(draft)
                                updatedWorkspace[updatedIndex].name = arg.name ?? draft[updatedIndex].name
                                updatedWorkspace[updatedIndex].lastAccessed = new Date()
                                Object.assign(draft, updatedWorkspace)
                            }
                            else if(arg.id) {
                                draft.splice(0, 0, {id: arg.id, name: arg.name, lastAccessed: new Date()})
                                draft.splice(draft.length - 1, 1)
                            }
                        })
                    )
                    try {
                        await queryFulfilled;
                    } catch (error) {
                        console.log(error);
                        patchResult.undo();
                        recentRefResults.undo();
                    }
                }
            }
        }),
        activateWorkspace: build.mutation<IActionResponse, string>({
            query: (arg) => ({
                url: `workspaces/${arg}/undelete`,
                method: 'PUT'
            }),
            invalidatesTags: (_response, _error, arg) =>  [
                {type: WORKSPACES_TYPE, id: arg},
                {type: WORKSPACES_TYPE, id: LIST},
            ],
            async onQueryStarted(arg, {dispatch, queryFulfilled}) {
                const finishedData = await queryFulfilled
                dispatch(
                    api.util.updateQueryData('getRecentWorkspaceRefs', undefined, (draft) => {
                        const updatedData = cloneDeep(draft)
                        const index = draft?.findIndex(a => a.id === finishedData.data.id);

                        if (index !== -1) {
                            updatedData[index].active = true
                            Object.assign(draft, updatedData)
                        }
                    })
                );
            }
        }),

        setSelectedWorkspace: build.mutation<null, string>({
            queryFn: (arg, {dispatch}) => {
                dispatch(setSelectedWorkspaceId(arg));
                return {data: null};
            },
            invalidatesTags: [
                {type: WORKSPACE_PRODUCTS_TYPE, id: LIST},
            ]
        }),
        clearWorkspaceCache: build.mutation<null, void>({
            queryFn: () => ({data: null}),
            invalidatesTags: [
                {type: WORKSPACES_TYPE, id: LIST},
                {type: WORKSPACE_PRODUCTS_TYPE, id: LIST},
                {type: WORKSPACE_METADATA_TYPE, id: LIST}
            ]
        }),
        getWorkspaceMetadata: build.query<ISavedExtensionField[], string>({
            query: (arg) => `workspaces/${arg}/extensionFields`,
            transformResponse: (response: IWorkspaceMetadata) => response.fields,
            providesTags: (results) => results
                ? [
                    ...results.map(m => ({type: WORKSPACE_METADATA_TYPE, id: `${m.extensionId}-${m.key}`} as const)),
                    {type: WORKSPACE_METADATA_TYPE, id: LIST}
                ]
                : [{type: WORKSPACE_METADATA_TYPE, id: LIST}]
        }),
        getWorkspaceMetadataField: build.query<ISavedExtensionField, { workspace: string, extension: string, field: string }>({
            query: (arg) => `workspaces/${arg.workspace}/extensionFields/${arg.extension}/${arg.field}`,
            transformResponse: (response: ISavedExtensionField, _base, arg) =>  response ??
                {extensionId: arg.extension, key: arg.field, value: ''},
            providesTags: (results) => results
                ? [{type: WORKSPACE_METADATA_TYPE, id: `${results.extensionId}-${results.key}`}]
                : []
        }),

        getWorkspaceExtensionMetadata: build.query<ISavedExtensionField[], {workspace: string, extension: string}>({
            query: (arg) => `workspaces/${arg.workspace}/extensionFields/${arg.extension}`,
            transformResponse: (response: IWorkspaceExtensionMetadata) => response.items,
            providesTags: (results) => results
                ? [
                    ...results.map(m => ({type: WORKSPACE_METADATA_TYPE, id: `${m.extensionId}-${m.key}`} as const)),
                    {type: WORKSPACE_METADATA_TYPE, id: LIST}
                ]
                : [{type: WORKSPACE_METADATA_TYPE, id: LIST}]
        }),
        setWorkspaceExtensionField: build.mutation<IActionResponse, { workspace: string, extension: string, field: string, value?: string }>({
            query: (arg) => ({
                url: `workspaces/${arg.workspace}/extensionFields/${arg.extension}/${arg.field}`,
                body: {value: arg.value},
                method: 'PUT',
            }),
            async onQueryStarted(arg, {dispatch, queryFulfilled}) {
                const patchResult = dispatch(
                    api.util.updateQueryData('getWorkspaceMetadataField', {workspace: arg.workspace, extension: arg.extension, field: arg.field}, (draft) => {
                        const newData : ISavedExtensionField = {extensionId: arg.extension, key: arg.field, value: arg.value ?? ""}
                        Object.assign(draft, newData);
                    })
                )
                try {
                    await queryFulfilled
                } catch (error) {
                    console.log(error)
                    patchResult.undo()
                }
                const workspaceMetadataResult = dispatch(
                    api.util.updateQueryData('getWorkspaceExtensionMetadata', {workspace: arg.workspace, extension: arg.extension}, (draft) => {
                        if(draft) {
                            const newData: ISavedExtensionField = {
                                extensionId: arg.extension,
                                key: arg.field,
                                value: arg.value ?? ""
                            }
                            const index = draft?.findIndex((a) => a.key == arg.field)
                            if(index === -1){
                                draft.push(newData)
                            }
                            else {
                                draft[index] = newData
                            }
                        }
                    })
                )
                try {
                    await queryFulfilled
                } catch (error) {
                    console.log(error)
                    workspaceMetadataResult.undo()
                }
            },

        }),

        //region Contacts
        getCompanies: build.query<ICollectionResponse<ICompany>, { query?: ISearchDataRequest, disabled?: boolean }>({
            query: (arg) => ({
                url: `contacts/companies/search?disabled=${arg.disabled ?? false}`,
                method: 'POST',
                body: arg.query
            }),
            serializeQueryArgs: ({endpointName}) => {
                return endpointName
            },
            forceRefetch({ currentArg, previousArg }) {
                return currentArg !== previousArg
            }
        }),
        getCompany: build.query<ICompany, string >({
            query: (arg) => `contacts/companies/${arg}?`
        }),
        // Products worth offering to someone adding to a workspace (omnibox workspace context).
        getWorkspaceProductSuggestions: build.query<IProductSuggestion[], { workspaceId: string, catalog: string, limit?: number }>({
            query: (arg) => `workspaces/${encodeURIComponent(arg.workspaceId)}/productSuggestions?catalog=${encodeURIComponent(arg.catalog)}${arg.limit ? `&limit=${arg.limit}` : ''}`,
            transformResponse: (response: ICollectionResponse<IProductSuggestion>) => response.items ?? [],
            providesTags: (_result, _error, arg) => [{type: WORKSPACE_PRODUCTS_TYPE, id: LIST}, {type: WORKSPACES_TYPE, id: arg.workspaceId}]
        }),
        // Products worth offering to someone editing a bundle (omnibox bundle context).
        getBundleProductSuggestions: build.query<IProductSuggestion[], { bundleId: string, catalog: string, limit?: number }>({
            query: (arg) => `productBundles/${encodeURIComponent(arg.bundleId)}/productSuggestions?catalog=${encodeURIComponent(arg.catalog)}${arg.limit ? `&limit=${arg.limit}` : ''}`,
            transformResponse: (response: ICollectionResponse<IProductSuggestion>) => response.items ?? [],
            providesTags: (_result, _error, arg) => [{type: 'ProductBundleItems' as const, id: arg.bundleId}]
        }),
        // A small page of real product results for the palette. Deliberately separate from
        // getSearchResults: that one records the search id for the Search page and shares its tag.
        getProductSearchPreview: build.query<ISearchQueryResponse, { catalog?: string, criteria: ISearchRequest }>({
            query: (arg) => ({
                url: `search/view?${arg.catalog ? `&catalog=${encodeURIComponent(arg.catalog)}` : ''}`,
                method: 'POST',
                body: arg.criteria
            })
        }),
        getCompanySuggestions: build.query<ICompanySuggestion[], { storefrontId?: string, limit?: number }>({
            query: (arg) => {
                const params = new URLSearchParams();
                if (arg.storefrontId) params.set('storefrontId', arg.storefrontId);
                if (arg.limit) params.set('limit', String(arg.limit));
                const qs = params.toString();
                return `contacts/companies/suggestions${qs ? `?${qs}` : ''}`;
            },
            transformResponse: (response: ICollectionResponse<ICompanySuggestion>) => response.items ?? [],
            providesTags: [{type: COMPANY_TYPE, id: LIST}]
        }),
        // Lightweight name search for pickers/the global search palette. getCompanies collapses all
        // args onto one cache entry (see the getContacts comment below for why that breaks search),
        // so this stays on default per-argument caching and must not gain a serializeQueryArgs override.
        searchCompanyRefs: build.query<ICollectionResponse<ICompany>, { searchTerm: string, pageSize?: number }>({
            query: (arg) => ({
                url: `contacts/companies/search?disabled=false`,
                method: 'POST',
                body: {
                    query: arg.searchTerm,
                    conditions: {
                        page: 1,
                        pageSize: arg.pageSize ?? 5,
                        searchTerm: arg.searchTerm,
                    },
                },
            }),
        }),
        getExtensionCompany: build.query<ICompany, { extensionId: string, companyIdentifier: string}>({
            query: (arg) => `extensions/company/${arg.extensionId}/companyDetails/${arg.companyIdentifier}`,
            transformResponse: (results: ICompanyResponse) => results?.company
        }),
        getImportCompanyExtensionOptions: build.query<IExtensionOptionsResponse, { extensionId: string, search: string }>({
            query: (arg) => ({
                url: `extensions/company/${arg.extensionId}/options`,
                method: 'POST',
                body: {
                    search: arg.search
                },
            })
        }),
        putCompany: build.mutation<IActionResponse, ICompany>({
            query: (arg) => ({
                url: arg.id == null ? `contacts/companies` : `contacts/companies/${arg.id}`,
                method: arg.id == null ? 'POST' : 'PUT',
                body: arg
            }),
            async onQueryStarted(arg, {dispatch}) {
                dispatch(
                    api.util.updateQueryData('getCompanies', {} , (draft) => {
                        const index = draft.items.findIndex(a => a.id === arg.id)
                        if(index !== -1) {
                            draft.items[index] = arg
                        }
                        else{
                            draft.items.push(arg)
                        }
                    })
                )
                dispatch(
                    api.util.updateQueryData('getCompany', '' , (draft) => {
                        Object.assign(draft, arg)
                    })
                );
            }
        }),
        deleteCompany: build.mutation<IActionResponse, string>({
            query: (arg) => ({
                url: `contacts/companies/${arg}`,
                method: 'DELETE'
            }),
            async onQueryStarted(arg, {dispatch, queryFulfilled}) {
                const finishedData = await queryFulfilled
                dispatch(
                    api.util.updateQueryData('getCompanies', {} , (draft) => {
                        const index = draft.items.findIndex(a => a.id === arg)
                        if(index > -1 && finishedData.data != undefined){
                            draft.items.splice(index, 1)
                        }
                    })
                );
            }

        }),
        disableCompany:  build.mutation<IActionResponse, string>({
            query: (arg) => ({
                url: `contacts/companies/${arg}/disable`,
                method: 'PUT'
            }),
            async onQueryStarted(arg, {dispatch, queryFulfilled}) {
                const patchResult = dispatch(
                    api.util.updateQueryData('getCompanies', {}, (draft) => {
                        const index = draft.items.findIndex(a => a.id === arg)
                        if (index !== -1) {
                            draft.items[index].disabled = true
                        }
                    })
                )
                try {
                    await queryFulfilled
                } catch (error){
                    console.log(error)
                    patchResult.undo()
                }
            }
        }),
        enableCompany: build.mutation<IActionResponse, string>({
            query: (arg) => ({
                url: `contacts/companies/${arg}/enable`,
                method: 'PUT'
            }), 
            async onQueryStarted(arg, {dispatch, queryFulfilled}) {
                const patchResult = dispatch(
                    api.util.updateQueryData('getCompanies', {}, (draft) => {
                        const index = draft.items.findIndex(a => a.id === arg)
                        if (index !== -1) {
                            draft.items[index].disabled = false
                        }
                    })
                )
                try {
                    await queryFulfilled
                } catch (error){
                    console.log(error)
                    patchResult.undo()
                }
            }
        }),
        getWorkspaceCompanyCount: build.query<number, string>({
            query: (arg) => `settings/companies/${arg}/workspaceCount`,
            providesTags: (results, _error, arg) => results
                ? [{type: COMPANY_COUNT_TYPE, id: arg}]
                : [],
        }),
        postGenerateContactsFromCompanies: build.mutation<IActionResponse, void>({
            query: () => ({
                url: 'contacts/contacts/generate/fromCompanies',
                method: 'POST',
            }),
        }),
        getLocationsForCompany: build.query<ICollectionResponse<ILocation>, {companyId: string, page?: number, pageSize?: number}>({
            query: (arg) => `contacts/companies/${arg.companyId}/locations?page=${arg.page ?? 1}&pageSize=${arg.pageSize ?? 100}`,
            providesTags: (_results, _error, arg) => [{type: LOCATION_TYPE, id: arg.companyId}],
        }),
        createLocation: build.mutation<IActionResponse, {companyId: string, location: ILocation}>({
            query: (arg) => ({
                url: `contacts/companies/${arg.companyId}/locations`,
                method: 'POST',
                body: arg.location,
            }),
            invalidatesTags: (_results, _error, arg) => [{type: LOCATION_TYPE, id: arg.companyId}, {type: COMPANY_TYPE, id: arg.companyId}],
        }),
        updateLocation: build.mutation<IActionResponse, {companyId: string, location: ILocation}>({
            query: (arg) => ({
                url: `contacts/locations/${arg.location.id}`,
                method: 'PUT',
                body: arg.location,
            }),
            invalidatesTags: (_results, _error, arg) => [{type: LOCATION_TYPE, id: arg.companyId}],
        }),
        deleteLocation: build.mutation<IActionResponse, {companyId: string, locationId: string}>({
            query: (arg) => ({
                url: `contacts/locations/${arg.locationId}`,
                method: 'DELETE',
            }),
            invalidatesTags: (_results, _error, arg) => [{type: LOCATION_TYPE, id: arg.companyId}, {type: COMPANY_TYPE, id: arg.companyId}],
        }),
        setCompanyDefaultLocation: build.mutation<IActionResponse, {companyId: string, locationId: string}>({
            query: (arg) => ({
                url: `contacts/companies/${arg.companyId}/defaultLocation/${arg.locationId || 'none'}`,
                method: 'PUT',
            }),
            invalidatesTags: (_results, _error, arg) => [{type: LOCATION_TYPE, id: arg.companyId}, {type: COMPANY_TYPE, id: arg.companyId}],
        }),
        getContacts: build.query<ICollectionResponse<IContact>, {query?: ISearchDataRequest, includeCompanyDetails?: boolean, disabled?: boolean, procurementContactType?: 'shipping' | 'billing'}>({
            query: (arg) => ({
                url: `contacts/contacts/search?includeCompanyDetails=${arg.includeCompanyDetails ?? false}&disabled=${arg.disabled ?? false}${arg.procurementContactType ? `&procurementContactType=${arg.procurementContactType}` : ''}`,
                method: 'POST',
                body: arg.query,
            }),
            // No serializeQueryArgs/forceRefetch override here on purpose. Collapsing every argument
            // set onto one cache entry is half of RTK's infinite-scroll pattern, and the other half --
            // `merge` -- was never here, so it bought nothing and broke search: each new term reused
            // the same entry, requests raced, and the last term typed frequently never got fetched at
            // all. The Add Users box would sit showing results for a stale prefix. Per-argument
            // caching is the default for good reason.
        }),
        getContactById: build.query<IContact, {contactId: string, includeCompanyDetails?: boolean}>({
           query: (arg) => ({
               url: `contacts/contacts/${arg.contactId}?includeCompanyDetails=${arg.includeCompanyDetails ?? false}`,
               method: 'GET'
           })
        }),
        getContactsForCompany: build.query<ICollectionResponse<IContact>, {companyId: string}>({
            query: (arg) => ({
                url: `contacts/companies/${arg.companyId}/contacts`,
            }),
            providesTags: (_results, _error, arg) => [{type: CONTACT_TYPE, id: arg.companyId}],
        }),
        saveContact: build.mutation<IActionResponse, IContact>({
            query: (arg) => ({
                url: arg.id == null ? `contacts/contacts` : `contacts/contacts/${arg.id}`,
                method: arg.id == null ? 'POST' : 'PUT',
                body: arg
            }),
            async onQueryStarted(arg, {dispatch, queryFulfilled}) {
                const patchResult = dispatch(
                    api.util.updateQueryData('getContacts', {}, (draft) => {
                        const index = draft.items.findIndex(a => a.id === arg.id)
                        if (index !== -1) {
                            draft.items[index] = arg
                        } else {
                            draft.items.push(arg)
                        }
                    })
                )
                try{
                    await queryFulfilled;
                } catch (error){
                    console.log(error)
                    patchResult.undo()
                }
            }
        }),
        disableContact: build.mutation<IActionResponse, string>({
            query: (arg) => ({
                url: `contacts/contacts/${arg}/disable`,
                method: 'PUT'
            }),
            async onQueryStarted(arg, {dispatch, queryFulfilled}) {
                const patchResult = dispatch(
                    api.util.updateQueryData('getContacts', {}, (draft) => {
                        const index = draft.items.findIndex(a => a.id === arg)
                        if (index !== -1) {
                            draft.items[index].disabled = true
                        }
                    })
                )
                try {
                    await queryFulfilled
                } catch (error){
                    console.log(error)
                    patchResult.undo()
                }
            }
        }),
        enableContact: build.mutation<IActionResponse, string>({
            query: (arg) => ({
                url: `contacts/contacts/${arg}/enable`,
                method: 'PUT'
            }),
            async onQueryStarted(arg, {dispatch, queryFulfilled}) {
                const patchResult = dispatch(
                    api.util.updateQueryData('getContacts', {}, (draft) => {
                        const index = draft.items.findIndex(a => a.id === arg)
                        if (index !== -1) {
                            draft.items[index].disabled = false
                        }
                    })
                )
                try {
                    await queryFulfilled
                } catch (error){
                    console.log(error)
                    patchResult.undo()
                }
            }
        }),
        deleteContact: build.mutation<IActionResponse, string>({
            query: (arg) => ({
                url: `contacts/contacts/${arg}`,
                method: 'DELETE'
            }),
            async onQueryStarted(arg, {dispatch, queryFulfilled}) {
                const finishedData = await queryFulfilled
                dispatch(
                    api.util.updateQueryData('getContacts', {}, (draft) => {
                        const index = draft.items.findIndex(a => a.id === arg)
                        if (index > -1 && finishedData.data != undefined) {
                            draft.items.splice(index, 1)
                        }
                    })
                )
            }
        }),
        //endregion
        uploadRecommendationFile: build.mutation<IUploadFileResponse, { extension: string, file: ArrayBuffer, fileName: string }>({
            query: (arg) => ({
                url: `extensions/recommendation/${arg.extension}/files`,
                method: 'POST',
                body: {
                    file: ArrayBufferToBase64(arg.file),
                    fileName: arg.fileName
                }
            })
        }),
        getWorkspaceRecommendations: build.query<IRecommendationResponse, { extensionId: string, workspace: string }>({
            query: (arg) => `workspaces/${arg.workspace}/recommendations/${arg.extensionId}`,
            providesTags: (_res, _err, arg) => ([
                {type: WORKSPACE_RECOMMENDATIONS_TYPE, id: `${arg.workspace}-${arg.extensionId}`},
            ])
        }),
        clearWorkspaceRecommendations: build.mutation<null, { extensionId: string, workspace: string }>({
            queryFn: () => ({data: null}),
            invalidatesTags: (_res, _err, arg) => ([
                {type: WORKSPACE_RECOMMENDATIONS_TYPE, id: `${arg.workspace}-${arg.extensionId}`},
            ])
        }),
        //endregion


        //region EXTENSIONS
        getUnmatchedExtensionProducts: build.query<ICollectionResponse<IUnmatchedExtensionProduct>, { extensionId: string, page?: number }>({
            query: (arg) => `extensions/installed/${arg.extensionId}/unmatched?${arg.page ? 'page=' + arg.page : ''}`,
            providesTags: () => [{id: LIST, type: EXTENSION_UNMATCHED_PRODUCT_TYPE}]
        }),
        // Merged purchase history (storefront orders + CRM won opportunities) for a single product,
        // backing the Purchase History tab on the product details panel. The API loads the product's
        // manufacturer and part number itself, so the caller only names the product.
        getProductPurchaseHistory: build.query<ICollectionResponse<IPurchaseHistoryItem>, { catalog: string, productId: string }>({
            query: (arg) => `catalog/${arg.catalog}/products/${arg.productId}/purchaseHistory`
        }),
        postConfirmExtensionProductMatch: build.mutation<IActionResponse, { extensionId: string, matchId: string, catalog: string, product: string}>({
            query: (arg) => ({
                url: `extensions/installed/${arg.extensionId}/unmatched/${arg.matchId}/confirm/${arg.catalog}/${arg.product}`,
                method: 'POST'
            }),
            invalidatesTags: () => [{type: EXTENSION_UNMATCHED_PRODUCT_TYPE, id: LIST}]
        }),
        postCreateExtensionProductFromUnmatched: build.mutation<IActionResponse, { extensionId: string, matchId: string, catalog: string }>({
            query: (arg) => ({
                url: `extensions/installed/${arg.extensionId}/unmatched/${arg.matchId}/create/${arg.catalog}`,
                method: 'POST'
            }),
            invalidatesTags: () => [{type: EXTENSION_UNMATCHED_PRODUCT_TYPE, id: LIST}]
        }),
        getExtensionLibrary: build.query<ICollectionResponse<IExtensionFile>, { extensionId: string, enabledOnly: boolean }>({
            query: (arg) => `extensions/installed/${arg.extensionId}/library?enabledOnly=${arg.enabledOnly}`,
            providesTags: (results, _, arg) => results
                ? [{type: EXTENSION_LIBRARY_TYPE, id: `${arg.extensionId}-${arg.enabledOnly}`}]
                : []
        }),
        postExtensionLibraryFile: build.mutation<IActionResponse, { extensionId: string, file: ArrayBuffer, files: any[] }>({
            invalidatesTags: (_1, _2, arg) =>
                [{type: EXTENSION_LIBRARY_TYPE, id: `${arg.extensionId}-true`}, { type: EXTENSION_LIBRARY_TYPE, id: `${arg.extensionId}-false`}],
            query: (arg) => ({
                url: `extensions/installed/${arg.extensionId}/library`,
                method: 'POST',
                body: {
                    file: ArrayBufferToBase64(arg.file),
                    fileName: arg.files[0].name,
                }
            })
        }),
        postEnableExtensionLibraryFile: build.mutation<IActionResponse, { extensionId: string, fileId: string }>({
            invalidatesTags: (_response, _error, arg) =>
                [{type: EXTENSION_LIBRARY_TYPE, id: `${arg.extensionId}-true`}, { type: EXTENSION_LIBRARY_TYPE, id: `${arg.extensionId}-false`}],
            query: (arg) => ({
                url: `extensions/installed/${arg.extensionId}/library/${arg.fileId}/enable`,
                method: 'POST',
            })
        }),
        postDisableExtensionLibraryFile: build.mutation<IActionResponse, { extensionId: string, fileId: string }>({
            invalidatesTags: (_response, _error, arg) =>
                [{type: EXTENSION_LIBRARY_TYPE, id: `${arg.extensionId}-true`}, { type: EXTENSION_LIBRARY_TYPE, id: `${arg.extensionId}-false`}],
            query: (arg) => ({
                url: `extensions/installed/${arg.extensionId}/library/${arg.fileId}/disable`,
                method: 'POST',
            })
        }),

        getInstalledExtensions: build.query<IInstalledExtension[], void>({
            query: () => 'extensions/installed',
            transformResponse: (results: IInstalledExtension[]) => results,
            providesTags: (results) => results
                ? [
                    ...results.map(e => ({type: INSTALLED_EXTENSION_TYPE, id: e.id} as const)),
                    {type: INSTALLED_EXTENSION_TYPE, id: LIST}
                ]
                : [{type: INSTALLED_EXTENSION_TYPE, id: LIST}],
        }),
        getInstalledExtension: build.query<IInstalledExtension, string>({
            query: (arg) => `extensions/installed/${arg}`,
            transformResponse: (results: IInstalledExtension) => results,
        }),
        disableInstalledExtension: build.mutation<IActionResponse, string>({
            query: (arg) => ({
                url: `extensions/installed/${arg}/disable`,
                method: 'POST',
            }),
            async onQueryStarted(arg, queryApi) {
                queryApi.dispatch(
                    api.util.updateQueryData('getInstalledExtensions', undefined, (draft) => {
                        const index = draft.findIndex((a) => a.id == arg)
                        draft[index].enabled = false;
                    })
                )
            }
        }),
        enableInstalledExtension: build.mutation<IActionResponse, string>({
            query: (arg) => ({
                url: `extensions/installed/${arg}/enable`,
                method: 'POST',
            }),
            async onQueryStarted(arg, queryApi) {
                queryApi.dispatch(
                    api.util.updateQueryData('getInstalledExtensions', undefined, (draft) => {
                        const index = draft.findIndex((a) => a.id == arg)
                        draft[index].enabled = true;
                    })
                )
            }
        }),
        deleteInstalledExtension: build.mutation<IActionResponse, string>({
            query: (arg) => ({
                url: `extensions/installed/${arg}`,
                method: 'DELETE',
            }),
            async onQueryStarted(arg, queryApi) {
                queryApi.dispatch(
                    api.util.updateQueryData('getInstalledExtensions', undefined, (draft) => {
                        const index = draft.findIndex((a) => a.id == arg)
                        draft.splice(index, 1);
                    })
                )
            }
        }),
        installExtension: build.mutation<IActionResponse, {extensionId: string, request: IExtensionInstallRequest}>({
            query: (arg) => ({
                url: `extensions/available/${arg.extensionId}/install`,
                method: 'POST',
                body: arg.request
            }),
            async onQueryStarted(arg, queryApi) {
                const id = await queryApi.queryFulfilled.then((a) => a.data.id)
                let extensions: IExtension[]  = [];
                queryApi.dispatch(
                    api.util.updateQueryData('getAvailableExtensions', undefined, (draft) => {
                        extensions = cloneDeep(draft);
                    })
                )
                await queryApi.queryFulfilled.then( () => {
                    const sourceExtensions = extensions.filter((a) => a.id == arg.extensionId);
                    if (sourceExtensions != undefined && sourceExtensions.length > 0) {
                        const sourceExtension = sourceExtensions[0];

                        queryApi.dispatch(
                            api.util.updateQueryData('getInstalledExtensions', undefined, (draft) => {
                                const extensions = cloneDeep(draft);
                                for (const object of sourceExtension.additionalData) {
                                    object.defaultValue = arg.request.additionalData[object.field]
                                }
                                //const additionalData = sourceExtension.additionalData.map((a) => a.defaultValue = arg.request.additionalData[a.field])
                                const newExtension: IInstalledExtension = {
                                    id: id,
                                    name: sourceExtension.name,
                                    enabled: true,
                                    extensionType: sourceExtension.category,
                                    source: sourceExtension.id,
                                    additionalData: sourceExtension.additionalData,
                                    nickname: arg.request.extensionNickname,
                                    vendor: arg.request.vendor ?? ""
                                }
                                extensions.push(newExtension);
                                Object.assign(draft, extensions);
                            })
                        )
                    }
                });
            },
        }),

        putInstalledExtension: build.mutation<IActionResponse, {extensionId: string, request: IExtensionInstallRequest}>({
            query: (arg) => ({
                url: `extensions/installed/${arg.extensionId}`,
                method: 'PUT',
                body: arg.request
            }),
            async onQueryStarted(arg, queryApi) {
                let extensions: IExtension[]  = [];
                queryApi.dispatch(
                    api.util.updateQueryData('getAvailableExtensions', undefined, (draft) => {
                        extensions = cloneDeep(draft);
                    })
                )
                const sourceExtensions = extensions.filter((a) => a.id == arg.extensionId);
                if (sourceExtensions != undefined && sourceExtensions.length > 0) {
                    const sourceExtension = sourceExtensions[0];
                    for (const object of sourceExtension.additionalData) {
                        object.defaultValue = arg.request.additionalData[object.field]
                    }
                    queryApi.dispatch(
                        api.util.updateQueryData('getInstalledExtensions', undefined, (draft) => {
                            const index = draft.findIndex((a) => a.id == arg.extensionId)
                            const update = draft[index]
                            update.nickname = arg.request.extensionNickname;
                            update.additionalData = sourceExtension.additionalData
                        })
                    )
                }
            }
        }),
        getAvailableExtensions: build.query<IExtension[], void>({
            query: () => 'extensions/available',
            transformResponse: (results: IExtension[]) => results,
            providesTags: (results) => results
                ? [
                    ...results.map(e => ({type: EXTENSION_TYPE, id: e.id} as const)),
                    {type: EXTENSION_TYPE, id: LIST}
                ]
                : [{type: EXTENSION_TYPE, id: LIST}],
        }),
        clearExtensions: build.mutation<null, void>({
            queryFn: () => ({data: null}),
            invalidatesTags: [
                EXTENSION_TYPE,
                {type: INSTALLED_EXTENSION_TYPE, id: LIST},
            ]
        }),
        getAvailableExtension: build.query<IExtension, string>({
            query: (arg) => `extensions/available/${arg}`,
            providesTags: (results) => [{type: EXTENSION_TYPE, id: results?.id }],
        }),
        getExtensionFolio: build.query<IInstalledExtensionFolio, string>({
            query: (arg) => `extensions/folios/${arg}`,
            providesTags: (_res, _err, arg) => ([
                {type: EXTENSION_FOLIO_TYPE, id: `${arg}`},
            ])
        }),
        // The CRM folios this organization could connect, flattened for the guided setup picker. One
        // call answers "what can I pick" and "have I already done this".
        getCrmFolioCandidates: build.query<ICollectionResponse<ICrmFolioCandidate>, void>({
            query: () => 'extensions/folios/crm',
            providesTags: [{type: EXTENSION_FOLIO_TYPE, id: LIST}]
        }),
        // Creates the installed folio record if it is missing and turns on the folio's default
        // sub-extensions, so the user only has to supply credentials. Invalidating the folio tags
        // makes the follow-up getExtensionFolio read the ready-to-fill detail view.
        quickSetupExtensionFolio: build.mutation<IActionResponse, string>({
            query: (arg) => ({
                url: `extensions/folios/${arg}/quickSetup`,
                method: 'POST'
            }),
            invalidatesTags: (_res, _err, arg) => ([
                {type: EXTENSION_FOLIO_TYPE, id: arg},
                {type: EXTENSION_FOLIO_TYPE, id: LIST},
                {type: INSTALLED_EXTENSION_TYPE, id: LIST},
                // Quick setup can complete a checklist step's prerequisites, so refresh the ring.
                {type: GETTING_STARTED_TYPE, id: LIST},
            ])
        }),
        // The PSA setup proposal for wedge-sourced organizations. Ensure is idempotent and queues
        // generation on first ask; the API answers 404 for organizations the feature does not apply
        // to, which the wizard treats as "no proposal" rather than an error.
        ensurePsaProposal: build.mutation<IPsaProvisioningProposal, string>({
            query: (folioId) => ({
                url: `extensions/folios/crm/${folioId}/proposal`,
                method: 'POST'
            })
        }),
        getPsaProposal: build.query<IPsaProvisioningProposal, string>({
            query: (folioId) => `extensions/folios/crm/${folioId}/proposal`,
            providesTags: (_res, _err, arg) => ([{type: PSA_PROPOSAL_TYPE, id: arg}])
        }),
        // The post-credential second pass: infer option-backed field values (opportunity status,
        // stage, categories, ...) from the connector's own option lists. Not wedge-gated; the API
        // answers 404 until credentials are stored, which the wizard treats as "not yet".
        ensurePsaFieldInference: build.mutation<IPsaProvisioningProposal, string>({
            query: (folioId) => ({
                url: `extensions/folios/crm/${folioId}/proposal/fields`,
                method: 'POST'
            }),
            invalidatesTags: (_res, _err, arg) => ([{type: PSA_PROPOSAL_TYPE, id: arg}])
        }),
        // The acceptance instrumentation: what a person did with a proposal, per field and overall.
        // Sent as the wizard is used so partial sessions still measure.
        recordPsaProposalDecision: build.mutation<IActionResponse, {folioId: string, request: IPsaProposalDecisionRequest}>({
            query: (arg) => ({
                url: `extensions/folios/crm/${arg.folioId}/proposal/decision`,
                method: 'POST',
                body: arg.request
            }),
            invalidatesTags: (_res, _err, arg) => ([{type: PSA_PROPOSAL_TYPE, id: arg.folioId}])
        }),
        // The wizard's explicit capability selection. Unlike quickSetup this REPLACES the enabled
        // set: the user was shown every capability and chose, so an uncheck must stick.
        setCrmFolioCapabilities: build.mutation<IActionResponse, {folioId: string, request: ICrmFolioCapabilitiesRequest}>({
            query: (arg) => ({
                url: `extensions/folios/crm/${arg.folioId}/capabilities`,
                method: 'POST',
                body: arg.request
            }),
            invalidatesTags: (_res, _err, arg) => ([
                {type: EXTENSION_FOLIO_TYPE, id: arg.folioId},
                {type: EXTENSION_FOLIO_TYPE, id: LIST},
                {type: GETTING_STARTED_TYPE, id: LIST},
            ])
        }),
        // Creates one real opportunity in the customer's CRM from stand-in order details, so the
        // configured settings are proved before a customer's first order rather than after it.
        createCrmTestOpportunity: build.mutation<ICrmTestOpportunityResponse, string>({
            query: (folioId) => ({
                url: `extensions/folios/crm/${folioId}/testOpportunity`,
                method: 'POST'
            })
        }),
        getStorefrontSubExtensionReferences: build.query<IExtensionFolioSubextensionReference[], void>({
            query: () => `extensions/folios/storefront`
        }),
        getSubExtensionFolioSubExtensionReferences: build.query<ICollectionResponse<IExtensionFolioSubextensionReference>, ExtensionType>({
            query: (arg) => `extensions/folios/subextensions/${arg}`
        }),
        putExtensionFolio: build.mutation<IActionResponse, {extensionId: string, request: IInstalledExtensionFolio}>({
            query: (arg) => ({
                url: `extensions/folios/${arg.extensionId}`,
                method: 'PUT',
                body: arg.request
            }),
            async onQueryStarted(arg, queryApi) {
                queryApi.dispatch(
                    api.util.updateQueryData('getExtensionFolio', arg.extensionId, (draft) => {
                        Object.assign(draft, arg.request)
                    })
                );
                // Folio settings auto-save from many controls with no save button, so the toast is the
                // only confirmation the change stuck. Toasted here rather than at each call site so every
                // save path reports the same way; the fixed toastId keeps a burst of field edits from
                // stacking a column of identical toasts.
                try {
                    const result = await queryApi.queryFulfilled;
                    if (result.data?.success === false) {
                        toast.error(result.data.message || 'Failed to save extension folio settings',
                            {toastId: 'folio-save-failed'});
                    } else {
                        toast.success('Extension folio settings saved', {toastId: 'folio-saved'});
                    }
                } catch {
                    toast.error('Failed to save extension folio settings', {toastId: 'folio-save-failed'});
                }
            }
        }),
        // Credentials-only save. Unlike putExtensionFolio this cannot touch enabled sub-extensions, the
        // schedule, or the target catalog: the server merges just these fields into the stored record. The
        // guided CRM setup uses it so a credential edit can never disable something an admin enabled.
        patchExtensionFolioCommonFields: build.mutation<IActionResponse, {extensionId: string, fields: { [key: string]: string }}>({
            query: (arg) => ({
                url: `extensions/folios/${arg.extensionId}/commonFields`,
                method: 'PATCH',
                body: { fields: arg.fields }
            }),
            async onQueryStarted(arg, queryApi) {
                queryApi.dispatch(
                    api.util.updateQueryData('getExtensionFolio', arg.extensionId, (draft) => {
                        draft.commonInstalledFields = { ...draft.commonInstalledFields, ...arg.fields };
                    })
                );
            }
        }),
        validateExtensionFolio: build.mutation<IValidateExtensionResponse, {id: string, request?: IFolioValidationRequest}>({
            query: (arg) => ({
                url: `extensions/folios/${arg.id}/validate`,
                method: 'POST',
                body: arg.request,
            }),
            // The server stamps the outcome on the installed record during this call, so every read of that
            // stamp is now stale. simpleValidate has always said so; this one did not, which is why a check
            // run from the folio panel left the home widget showing the previous verdict until something
            // else happened to refetch it.
            invalidatesTags: [
                {type: INTEGRATION_HEALTH_TYPE, id: LIST},
                {type: GETTING_STARTED_TYPE, id: LIST},
            ]
        }),
        enableFolioSubExtension: build.mutation<IActionResponse, {id: string, subExtension: string}>({
            query: (arg) => ({
                url: `extensions/folios/${arg.id}/${arg.subExtension}/enable`,
                method: 'POST'
            }),
            async onQueryStarted(arg, queryApi) {
                queryApi.dispatch(
                    api.util.updateQueryData('getExtensionFolio', arg.id, (draft) => {
                        if(!draft?.enabledSubExtensions?.includes(arg.subExtension)){
                            draft?.enabledSubExtensions?.push(arg.subExtension)
                        }
                    })
                );
            }
        }),
        simpleValidateExtensionFolio: build.mutation<IValidateExtensionResponse, {id: string}>({
            query: (arg) => ({
                url: `extensions/folios/${arg.id}/simpleValidate`,
                method: 'POST'
            }),
            // A validation stamps the folio's health and can complete/regress the checklist's CRM step,
            // so both reads refresh together with the result the user just saw.
            invalidatesTags: [
                {type: INTEGRATION_HEALTH_TYPE, id: LIST},
                {type: GETTING_STARTED_TYPE, id: LIST},
            ]
        }),
        getInstalledExtensionLogs: build.query<ICollectionResponse<IExtensionLog>, string>({
            query: (arg) => `extensions/installed/${arg}/logs`,
            providesTags: (_results, _error, arg) => [{type: INSTALLED_EXTENSION_LOGS_TYPE, id: arg}]
        }),
        // Centralized extension activity log for a context (folio source id or installed-extension id),
        // optionally narrowed to a single sub-extension. Backs the Activity pivot on the extension panels.
        getExtensionActivities: build.query<ICollectionResponse<IExtensionActivity>, { context: string, subExtension?: string, count?: number }>({
            query: (arg) => {
                const params = new URLSearchParams();
                if (arg.subExtension) params.set('subExtension', arg.subExtension);
                if (arg.count) params.set('count', String(arg.count));
                const qs = params.toString();
                return `extensions/installed/${arg.context}/activities${qs ? `?${qs}` : ''}`;
            },
            providesTags: (_results, _error, arg) => [{type: EXTENSION_ACTIVITIES_TYPE, id: arg.context}]
        }),
        getExportExtensionOptions: build.query<IExtensionOptionsResponse, { extensionId: string, field: string, search?: string, additionalData?: { [key: string]: string }, workspaceId?: string }>({
            query: (arg) => ({
                url: `extensions/export/${arg.extensionId}/${arg.field}/options`,
                method: 'POST',
                body: {
                    additionalData: arg.additionalData,
                    search: arg.search,
                    workspace: arg.workspaceId
                },
            })
        }),
        // Ranked suggestions for a field (what this user would most likely pick), e.g. their own recent open
        // PSA opportunities. Same response shape as options; unsupported fields answer success=false.
        getExportExtensionSuggestions: build.query<IExtensionOptionsResponse, { extensionId: string, field: string, search?: string, limit?: number, page?: number, sortBy?: string, sortByDescending?: boolean, filterField?: string, filterValue?: string, additionalData?: { [key: string]: string }, workspaceId?: string }>({
            query: (arg) => ({
                url: `extensions/export/${arg.extensionId}/${arg.field}/suggestions`,
                method: 'POST',
                body: {
                    additionalData: arg.additionalData,
                    search: arg.search,
                    limit: arg.limit,
                    // Page turns the ranked shortlist into a paged listing with totalCount.
                    page: arg.page,
                    sortBy: arg.sortBy,
                    sortByDescending: arg.sortByDescending,
                    filterField: arg.filterField,
                    filterValue: arg.filterValue,
                    workspace: arg.workspaceId
                },
            })
        }),
        getExtensionFieldMetadata: build.query<IExtensionFieldMetadataResponse, { extensionId: string, field: string, additionalData?: { [key: string]: string }, workspaceId?: string }>({
            query: (arg) => ({
                url: `extensions/export/${arg.extensionId}/${arg.field}/fieldMetadata`,
                method: 'POST',
                body: {
                    additionalData: arg.additionalData,
                    workspace: arg.workspaceId
                },
            })
        }),
        getExportExtensionOptionFriendlyName: build.query<string, { extensionId: string, field: string, search: string, additionalData?: { [key: string]: string } }>({
            query: (arg) => ({
                url: `extensions/export/${arg.extensionId}/${arg.field}/options/friendlyName`,
                method: 'POST',
                body: {
                    search: arg.search,
                    additionalData: arg.additionalData
                },
            })
        }),
        // Fetch options for several fields in one call. Returns a map of field -> that field's options, or null
        // when the extension declares no batch URL (the caller then falls back to per-field options).
        getExtensionOptionsBatch: build.query<{ [field: string]: IExtensionOptionsResponse } | null, { extensionId: string, fields: string[], additionalData?: { [key: string]: string }, workspaceId?: string }>({
            query: (arg) => ({
                url: `extensions/export/${arg.extensionId}/options/batch`,
                method: 'POST',
                body: {
                    additionalData: arg.additionalData,
                    fields: arg.fields,
                    workspace: arg.workspaceId
                },
            })
        }),
        getExtensionInstallOptions: build.query<IExtensionOptionsResponse, { extensionId: string, field: string}>({
            query: (arg) => ({
                url: `extensions/available/${arg.extensionId}/${arg.field}/installOptions`,
                method: 'GET'
            })
        }),
        getExtensionPotentialMatches: build.query<IExtensionPotentialMatchResponse, { extensionId: string, products: IProductReference[] }>({
            query: (arg) => ({
                url: `extensions/installed/${arg.extensionId}/possibleMatches/products`,
                method: 'POST',
                body: {
                    products: arg.products,
                }
            }),
            providesTags: [EXTENSION_POSSIBLE_MATCH]
        }),
        confirmExtensionPotentialMatch: build.mutation<IActionResponse, { extensionId: string, catalog: string, productId: string, externalId: string}>({
            query: (arg) => ({
                url: `extensions/installed/${arg.extensionId}/possibleMatches/products/${arg.catalog}/${arg.productId}/confirm/${arg.externalId}`,
                method: 'POST',
            }),
        }),
        getImportSample: build.query<IImportExtensionMappingSampleResponse, { extensionId: string, request: IImportExtensionMappingSampleRequest }>({
            query: (arg) => ({
                url: `extensions/available/${arg.extensionId}/getSample`,
                method: 'POST',
                body: arg.request
            }),
        }),
        getDirectImportPreview: build.query<IDirectImportExtensionPreviewResponse, { extensionId: string, fieldName :string, request: IDirectImportExtensionPreviewRequest }>({
            query: (arg) => ({
                url: `extensions/directImport/${arg.extensionId}/itemPreview/${arg.fieldName}`,
                method: 'POST',
                body: arg.request
            })
        }),
        
        runExportExtension: build.mutation<IExtensionResponse, { extensionId: string, products?: IProductReference[], workspace?: string, additionalFields?: { [key: string]: string }}>({
            query: (arg) => ({
                url: (`extensions/export/${arg.extensionId}/run`),
                method: 'POST',
                body: {
                    products: arg.products,
                    workspace: arg.workspace,
                    additionalFields: arg.additionalFields
                }
            }),
            invalidatesTags: [
                {type: EXTENSION_LINK_TYPE, id: LIST},
                {type: EXTENSION_POSSIBLE_MATCH}
            ]
        }),
        runImportExtension: build.mutation<IActionResponse, { extensionId: string }>({
            query: (arg) => ({
                url: (`extensions/import/${arg.extensionId}/run`),
                method: 'POST'
            }),
            invalidatesTags: (_r, _e, arg) => [{
                type: EXTENSION_ACTIVITIES_TYPE,
                id: arg.extensionId.startsWith('folio_') ? arg.extensionId.split('_')[1] : arg.extensionId
            }]
        }),
        // subExtensions narrows the run to specific sub-extension identifiers, and is the only way to start a
        // runnable type other than a plain import (purchase history has to be named). Omitting it runs every
        // enabled import sub-extension, so a caller that does not care never kicks off a heavyweight pull.
        runImportExtensionsForFolio: build.mutation<IActionResponse, { folioId: string, subExtensions?: string[] }>({
            query: (arg) => ({
                url: (`extensions/import/folio/${arg.folioId}/run`),
                method: 'POST',
                body: {subExtensions: arg.subExtensions ?? []}
            }),
            invalidatesTags: (_r, _e, arg) => [{type: EXTENSION_ACTIVITIES_TYPE, id: arg.folioId}]
        }),
        runDirectImportExtension: build.mutation<IDirectImportExtensionResponse, { extensionId: string, request: IDirectImportExtensionRequest}>({
            query: (arg) => ({
                url: (`extensions/directImport/${arg.extensionId}/run`),
                body: arg.request,
                method: 'POST'
            }),
            async onQueryStarted(arg, queryApi) {
                const result = await queryApi.queryFulfilled;
                queryApi.dispatch(
                    api.util.updateQueryData('getWorkspaceProducts', arg.request.workspaceId, (draft) => {
                        if (result?.data?.items) {
                            draft.push(...result.data.items)
                        }
                    })
                );
            }
        }),
        runDocumentExtension: build.mutation<IExtensionResponse, { extensionId: string, workspaceId: string, templateId?: string }>({
            query: (arg) =>{
                const url = arg.templateId ? `extensions/document/${arg.extensionId}/workspace/${arg.workspaceId}?templateId=${arg.templateId}` :
                    `extensions/document/${arg.extensionId}/workspace/${arg.workspaceId}`
                return ({
                url: url,
                method: 'POST'
            })},
            async onQueryStarted(arg, queryApi) {
                const result = await queryApi.queryFulfilled;
                queryApi.dispatch(
                    api.util.updateQueryData('getWorkspace', arg.workspaceId, draft => {
                        if (result.data.redirectUrl) {
                            draft.documentIsCurrent = true
                            draft.documentUrl = result.data.redirectUrl
                            draft.mostRecentDocumentExtension = arg.extensionId
                        }
                    })
                );
            }
        }),
        runRealtimeSearchExtension: build.mutation<ICollectionResponse<IProduct>, { request: ISearchRequest }>({
            query: (arg) => ({
                url: 'extensions/realtime/search',
                method: 'POST',
                body: arg.request
            })
        }),
        runRealtimeExtension: build.mutation<IRealTimeExtensionResponse, { extension: IInstalledExtension, products?: IProductReference[], workspace?: string }>({
            query: (arg) => ({
                url: (`extensions/realtime/${arg.extension.id}/run`),
                method: 'POST',
                body: {
                    products: arg.products,
                    workspace: arg.workspace,
                }
            }),
            async onQueryStarted(arg, queryApi) {
                try {
                    const result = await queryApi.queryFulfilled;
                    const state = await queryApi.getState() as RootState;
                    const criteria = state.search.criteria;
                    const catalog = state.search.selectedCatalog;
                    if (result.data.items == null || result.data.items.length === 0) {
                        return;
                    }
                    if (arg.products) {
                        queryApi.dispatch(api.util.updateQueryData('getSearchResults', {
                            catalog: catalog?.name,
                            criteria
                        }, (draft) => {
                            const products = cloneDeep(draft.products);
                            for (const product of products) {
                                const pRef = arg.products?.find(p => p.id === product.id);
                                if (pRef == null) continue;
                                updateProductFromRealtime(product, result.data, arg.extension.vendor, pRef);
                            }
                            Object.assign(draft, {...draft, products});
                        }));
                    }
                    if (arg.workspace) {
                        queryApi.dispatch(api.util.updateQueryData('getWorkspaceProducts', arg.workspace, (draft) => {
                            const products = cloneDeep(draft);
                            for (const product of products) {
                                if (product.normalized != null) {
                                    const pRef = {id: product.normalized.id, catalog: product.normalized.catalog, quantity: product.details.quantity};
                                    updateProductFromRealtime(product.normalized, result.data, arg.extension.vendor, pRef);
                                }
                                if (product.product != null) {
                                    const pRef = {id: product.product.id, catalog: product.product.catalog, quantity: product.details.quantity};
                                    updateProductFromRealtime(product.product, result.data, arg.extension.vendor, pRef);
                                }
                                updateWorkspaceItemFromRealtime(product, result.data, arg.extension.vendor);
                            }
                            Object.assign(draft, products);
                        }));
                    }
                } catch {
                    console.error(`Error getting realtime for ${arg.extension.id}`)
                }
            }
        }),
        validateExtensionSettings: build.mutation<IValidateExtensionResponse, {id: string, request: IExtensionInstallRequest}>({
            query: (arg) => ({
                url: `extensions/available/${arg.id}/validate`,
                method: 'POST',
                body: arg.request,
            }),
        }),
        validateInstalledExtension: build.mutation<IValidateExtensionResponse, {id: string, request: IExtensionInstallRequest}>({
            query: (arg) => ({
                url: `extensions/installed/${arg.id}/validate`,
                method: 'POST',
                body: arg.request,
            })
        }),
        simpleValidateInstalledExtension: build.mutation<IValidateExtensionResponse, {id: string}>({
            query: (arg) => ({
                url: `extensions/installed/${arg.id}/validate`,
            }),
            // A validation stamps the install's health; refresh the home widget with the fresh outcome.
            invalidatesTags: [{type: INTEGRATION_HEALTH_TYPE, id: LIST}]
        }),
        //endregion

        //region PRODUCTS
        getMetadata: build.query<IMetadata, string | undefined>({
            query: (arg) => arg ? `search/metadata?catalog=${arg}` : 'search/metadata',
        }),
        getFavorites: build.query<IFavoriteLookup, void>({
            query: () => 'search/favorites?',
            providesTags: ['Favorites'],
            transformResponse: (response: ISearchQueryResponse) => {
                const favorites: IFavoriteLookup = {};
                for (const product of response.products) {
                    if (product?.favorite?.company || product?.favorite?.user) {
                        favorites[product.id] = {company: product.favorite.company, user: product.favorite.user}
                    } else {
                        favorites[product.id] = {company: false, user: true}
                    }
                }
                return favorites;
            }
        }),
        getFavoritesProducts: build.query<ISearchQueryResponse, void>({
            query: () => 'search/favorites?',
            providesTags: ['Favorites'],
        }),
        setUserFavorite: build.mutation<IActionResponse, { catalog: string, id: string }>({
            query: (arg) => ({
                url: `catalog/${arg.catalog}/products/${arg.id}/favorites/user`,
                method: 'PUT'
            }),
            onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
                const patchResult = dispatch(
                    api.util.updateQueryData('getFavorites', undefined, draft => {
                        draft[arg.id] = {
                            company: draft[arg.id]?.company ?? false,
                            user: true,
                        }
                    })
                );
                try {
                    await queryFulfilled;
                } catch {
                    patchResult.undo();
                }
            },
        }),
        removeUserFavorite: build.mutation<IActionResponse, { catalog: string, id: string }>({
            query: (arg) => ({
                url: `catalog/${arg.catalog}/products/${arg.id}/favorites/user`,
                method: 'DELETE'
            }),
            onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
                const patchResult = dispatch(
                    api.util.updateQueryData('getFavorites', undefined, draft => {
                        draft[arg.id] = {
                            company: draft[arg.id]?.company ?? false,
                            user: false,
                        }
                    })
                );
                try {
                    await queryFulfilled;
                } catch {
                    patchResult.undo();
                }
            }
        }),
        setCompanyFavorite: build.mutation<IActionResponse, { catalog: string, id: string }>({
            query: (arg) => ({
                url: `catalog/${arg.catalog}/products/${arg.id}/favorites/organization`,
                method: 'PUT'
            }),
            onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
                const patchResult = dispatch(
                    api.util.updateQueryData('getFavorites', undefined, draft => {
                        draft[arg.id] = {
                            company: true,
                            user: draft[arg.id]?.user ?? false,
                        }
                    })
                );
                try {
                    await queryFulfilled;
                } catch {
                    patchResult.undo();
                }
            },
        }),
        removeCompanyFavorite: build.mutation<IActionResponse, { catalog: string, id: string }>({
            query: (arg) => ({
                url: `catalog/${arg.catalog}/products/${arg.id}/favorites/organization`,
                method: 'DELETE'
            }),
            onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
                const patchResult = dispatch(
                    api.util.updateQueryData('getFavorites', undefined, draft => {
                        draft[arg.id] = {
                            company: false,
                            user: draft[arg.id]?.user ?? false,
                        }
                    })
                );
                try {
                    await queryFulfilled;
                } catch {
                    patchResult.undo();
                }
            }
        }),
        getProductTags: build.query<IProductTagsResponse, {searchTerm: string}>({
            query: (arg) => ({
                url: `search/tags/${arg.searchTerm}`,
                method: 'GET',
            })
        }),
        getSearchResults: build.query<ISearchQueryResponse, { catalog?: string, criteria: ISearchRequest }>({
            query: (arg) => {
                if (criteriaIsBlank(arg.criteria))
                    return {
                        url: 'search/favorites?'
                    }
                let url = 'search/view?';
                if (arg.catalog) {
                    url += `&catalog=${arg.catalog}`
                }
                return {
                    url,
                    method: 'POST',
                    body: arg.criteria
                }
            },
            providesTags: [SEARCH_RESULTS_TYPE],
            async onQueryStarted(_arg, {dispatch, queryFulfilled}) {
                queryFulfilled.then((a) => {
                    dispatch(updateSearchId(a.data.searchLogId))
                })
            }
        }),

        // Facet-only preview of a search for the global search palette's attribute suggestions:
        // one item of payload, default per-arg caching, and none of getSearchResults' session
        // side effects (updateSearchId) — the palette must not disturb the search page's state.
        getSearchFacetPreview: build.query<ISearchQueryResponse, { catalog?: string, criteria: ISearchRequest }>({
            query: (arg) => ({
                url: arg.catalog ? `search/view?&catalog=${arg.catalog}` : 'search/view?',
                method: 'POST',
                body: { ...arg.criteria, page: 1, pageSize: 1, facetValueCount: 20 },
            }),
        }),
        // A full search for a composer mounted somewhere other than the search page, without the two
        // page-level behaviours getSearchResults carries. It never redirects a "blank" criteria set to the
        // favorites list: the omnibox can compose a query out of fields that test does not look at (a part
        // number, a subcategory, an attribute boost), and answering one of those with the user's favorites
        // would be a different list entirely. It leaves the search session alone too, for the same reason
        // the palette's facet preview does: an embedded search is not the page's search.
        getEmbeddedSearchResults: build.query<ISearchQueryResponse, { catalog?: string, criteria: ISearchRequest }>({
            query: (arg) => ({
                url: arg.catalog ? `search/view?&catalog=${arg.catalog}` : 'search/view?',
                method: 'POST',
                body: arg.criteria,
            }),
        }),
        getSearchMetadata: build.query<IMetadata, void>({
            query: () => 'search/metadata',
        }),
        getSearchSuggestions: build.query<ISearchSuggestions, { category?: string } | void>({
            query: (arg) => arg && arg.category
                ? `search/suggestions?category=${encodeURIComponent(arg.category)}`
                : 'search/suggestions',
        }),
        postSearchTableRow: build.query<ICollectionResponse<IProduct>, { catalog?: string, values: string[], manufacturerPartNumber?: string, productName?: string }>({
            query: (arg) => ({
                url: `search/tablerow`,
                method: 'POST',
                body: arg
            })
        }),
        updateProductVisit: build.mutation<boolean, {catalog: string, id: string}>({
            query: (arg) => ({
                url: `catalog/${arg.catalog}/products/${arg.id}/logvisit`,
                method: 'POST'
            })
        }),
        getItemExtensionFields: build.query<ISavedExtensionField[], { catalog: string, id: string, extension: string }>({
            query: (arg) => `catalog/${arg.catalog}/products/${arg.id}/extensionFields/${arg.extension}`,
            transformResponse: (response: IGetExtensionFieldsResponse) => response.fields,
            providesTags: (results, _base, arg) => results
                ? [
                    ...results.map(r => ({
                        type: ITEM_EXTENSION_FIELD_TYPE,
                        id: `${arg.catalog}-${arg.id}-${arg.extension}-${r.key}`
                    } as const)),
                    {type: ITEM_EXTENSION_FIELD_TYPE, id: LIST}
                ]
                : [{type: ITEM_EXTENSION_FIELD_TYPE, id: LIST}]
        }),
        putItemExtensionField: build.mutation<IActionResponse, { catalog: string, id: string, extension: string, field: string, value: string }>({
            query: (arg) => ({
                url: `catalog/${arg.catalog}/products/${arg.id}/extensionFields/${arg.extension}/${arg.field}`,
                method: 'PUT',
                body: {
                    value: arg.value
                }
            }),
            invalidatesTags: (_result, _base, arg) => [
                {type: ITEM_EXTENSION_FIELD_TYPE, id: `${arg.catalog}-${arg.id}-${arg.extension}-${arg.field}`},
            ],
            async onQueryStarted(arg, {dispatch, queryFulfilled}) {
                const patchResult = dispatch(
                    api.util.updateQueryData('getItemExtensionFields', {
                        catalog: arg.catalog,
                        id: arg.id,
                        extension: arg.extension
                    }, (draft) => {
                        const newFields = cloneDeep(draft);
                        newFields[newFields.findIndex(f => f.key === arg.field)] = {
                            extensionId: arg.extension,
                            key: arg.field,
                            value: arg.value
                        };
                        Object.assign(draft, newFields);
                    })
                );
                try {
                    await queryFulfilled
                } catch {
                    patchResult.undo();
                }
            }
        }),
        getItemDetails: build.query<INormalizedProduct, IProductReference>({
            query: (arg) => `catalog/${arg.catalog}/products/${arg.id}`,
            transformResponse: (result: IProduct) => NormalizeResult(result),
            providesTags: (_result, _error, arg) => [{type: ITEM_DETAILS_TYPE, id: `${arg.catalog}-${arg.id}`}]
        }),
        getMultipleItemDetails: build.query<INormalizedProduct[], { catalog: string, ids: string[] }>({
            query: (arg) => ({
                url: `catalog/${arg.catalog}/retrieveProducts`,
                method: 'POST',
                body: {
                    ids: arg.ids,
                }
            }),
            transformResponse: (result: IProduct[]) => result.map(p => NormalizeResult(p)),
            providesTags: (result) => result
                ? [
                    ...result.map(p => ({type: ITEM_DETAILS_TYPE, id: `${p.catalog}-${p.id}`} as const)),
                    {type: ITEM_DETAILS_TYPE, id: LIST}
                ]
                : [{type: ITEM_DETAILS_TYPE, id: LIST}]
        }),
        getProductLinkedItems: build.query<IProductLinkedItem[], { catalog: string, productId: string }>({
            query: (arg) => `catalog/${arg.catalog}/products/${arg.productId}/linkedItems`,
            transformResponse: (result: ICollectionResponse<IProductLinkedItem>) => result.items,
            providesTags: (_result, _error, arg) => [{type: PRODUCT_LINKED_ITEMS_TYPE, id: arg.productId}]
        }),
        getLinkedItemTypes: build.query<string[], { catalog: string }>({
            query: (arg) => `catalog/${arg.catalog}/products/linkedItems/types`,
            transformResponse: (result: ICollectionResponse<string>) => result.items,
            providesTags: [{type: LINKED_ITEM_TYPES_TYPE, id: LIST}]
        }),
        saveProductLinkedItems: build.mutation<IActionResponse, { catalog: string, productId: string, links: IProductLinkedItemEntry[] }>({
            query: (arg) => ({
                url: `catalog/${arg.catalog}/products/${arg.productId}/linkedItems`,
                method: 'POST',
                body: {links: arg.links}
            }),
            invalidatesTags: (_result, _error, arg) => [
                {type: PRODUCT_LINKED_ITEMS_TYPE, id: arg.productId},
                {type: LINKED_ITEM_TYPES_TYPE, id: LIST}
            ]
        }),
        deleteProductLinkedItem: build.mutation<IActionResponse, { catalog: string, productId: string, linkedProductId: string }>({
            query: (arg) => ({
                url: `catalog/${arg.catalog}/products/${arg.productId}/linkedItems/${arg.linkedProductId}`,
                method: 'DELETE'
            }),
            invalidatesTags: (_result, _error, arg) => [{type: PRODUCT_LINKED_ITEMS_TYPE, id: arg.productId}]
        }),
        bulkListOnStorefront: build.mutation<IBulkStorefrontListingResponse, {catalog: string; request: IBulkStorefrontListingRequest}>({
            query: (arg) => ({
                url: `catalog/${arg.catalog}/products/storefronts/bulk`,
                method: 'POST',
                body: arg.request
            }),
            // Mirror the refetch surface of putProduct: search results + the affected product details.
            invalidatesTags: (_result, _error, arg) => [
                SEARCH_RESULTS_TYPE,
                {type: ITEM_DETAILS_TYPE, id: LIST},
                ...arg.request.productIds.map(id => ({type: ITEM_DETAILS_TYPE, id: `${arg.catalog}-${id}`} as const)),
            ]
        }),
        postProduct: build.mutation<IActionResponse, {product: INewProduct, catalog: string }>({
            query: (arg) => ({
                url: `catalog/${arg.catalog}/products`,
                method: 'POST',
                body: arg.product
            })
        }),
        putProduct: build.mutation<IActionResponse, INormalizedProduct>({
            query: (arg) => ({
                url: `catalog/${arg.catalog}/products/${arg.id}`,
                method: 'PUT',
                body: arg
            }),
            async onQueryStarted(arg, queryApi) {
                const state = await queryApi.getState() as RootState;
                const workspace = state.settings?.selectedWorkspaceId ?? ""
                
                const criteria = state.search.criteria;
                const catalog = state.search.selectedCatalog;
                
                //Fix search results with modified product
                const searchResultsUpdate = queryApi.dispatch(api.util.updateQueryData('getSearchResults', {
                    catalog: catalog?.name,
                    criteria
                }, (draft) => {
                    const products = cloneDeep(draft.products);
                    const item = products.findIndex(a => a.id == arg.id)
                    products[item] = arg;
                    Object.assign(draft, {...draft, products});
                }));

                const productDetailsUpdate = queryApi.dispatch(api.util.updateQueryData('getItemDetails', {
                    catalog: arg.catalog,
                    id: arg.id
                }, (draft) => {
                    Object.assign(draft, arg);
                }))
                
                let products: IWorkspaceItem[] = [];
                
                //Fix workspace with modified product
                const workspaceUpdate = queryApi.dispatch(
                    api.util.updateQueryData('getWorkspaceProducts', workspace, (draft) => {
                        products = cloneDeep(draft);
                        const i = products.findIndex(p => p.productId === arg.id);
                        if (i === -1) return;
                        const prod = products[i]
                        prod.product = arg;
                        Object.assign(draft, products)
                    })
                );

                let favorites: ISearchQueryResponse;

                //Fix favorites with modified product
                const favoritesUpdate = queryApi.dispatch(
                    api.util.updateQueryData('getFavoritesProducts', undefined, (draft) => {
                        favorites = cloneDeep(draft);
                        const i = favorites.products.findIndex(p => p.id === arg.id);
                        if (i === -1) return;
                        favorites.products[i] = arg
                        Object.assign(draft, favorites)
                    })
                );

                try {
                    await queryApi.queryFulfilled
                } catch (error) {
                    console.log(error);
                    workspaceUpdate.undo()
                    searchResultsUpdate.undo()
                    favoritesUpdate.undo()
                    productDetailsUpdate.undo()
                }
            },
        }),
        // Catalog Sync (A6): reset chosen fields (or all edited fields) back to the base-catalog
        // values and clear their tenant-edit locks.
        resetProductToCatalog: build.mutation<IActionResponse, {catalog: string, id: string, fields?: string[]}>({
            query: (arg) => ({
                url: `catalog/${arg.catalog}/products/${arg.id}/resetToCatalog`,
                method: 'POST',
                body: {items: arg.fields ?? []}
            }),
            invalidatesTags: (_result, _error, arg) => [{type: ITEM_DETAILS_TYPE, id: `${arg.catalog}-${arg.id}`}]
        }),
        getWorkspaceProducts: build.query<IWorkspaceItem[], string>({
            query: (arg) => `workspaces/${arg}/items`,
            transformResponse: (response: ICollectionResponse<IWorkspaceItem>) => response.items.map(p => ({
                ...p,
                normalized: p.product ? NormalizeResult(p.product) : undefined
            })),
            providesTags: (results) => results
                ? [...results.map(w => ({type: WORKSPACE_PRODUCTS_TYPE, id: w.id} as const)),
                    { type: WORKSPACE_PRODUCTS_TYPE, id: LIST }]
                : [{type: WORKSPACE_PRODUCTS_TYPE, id: LIST}],
        }),
        putTags: build.mutation<IActionResponse, {tags: string[], productId: string, catalog: string}>({
            query: (arg) => ({
                url: `catalog/${arg.catalog}/products/${arg.productId}/tags`,
                method: 'PUT',
                body: arg.tags
            }),
            async onQueryStarted(arg, queryApi) {
                const state = await queryApi.getState() as RootState;
                const workspace = state.settings?.selectedWorkspaceId ?? ""

                const criteria = state.search.criteria;
                const catalog = state.search.selectedCatalog;

                //Fix search results with modified product
                const searchResultsUpdate = queryApi.dispatch(api.util.updateQueryData('getSearchResults', {
                    catalog: catalog?.name,
                    criteria
                }, (draft) => {
                    const products = cloneDeep(draft.products);
                    const item = products.findIndex(a => a.id == arg.productId)
                    products[item].tags = arg.tags;
                    Object.assign(draft, {...draft, products});
                }));

                let products: IWorkspaceItem[] = [];

                //Fix workspace with modified product
                const workspaceUpdate = queryApi.dispatch(
                    api.util.updateQueryData('getWorkspaceProducts', workspace, (draft) => {
                        products = cloneDeep(draft);
                        const i = products.findIndex(p => p.productId === arg.productId);
                        if (i === -1) return;
                        const prod = products[i];
                        if(prod.product) {
                            prod.product.tags = arg.tags
                            Object.assign(draft, products)
                        }
                    })
                );

                let favorites: ISearchQueryResponse;

                //Fix favorites with modified product
                const favoritesUpdate = queryApi.dispatch(
                    api.util.updateQueryData('getFavoritesProducts', undefined, (draft) => {
                        favorites = cloneDeep(draft);
                        const i = favorites.products.findIndex(p => p.id === arg.productId);
                        if (i === -1) return;
                        const prod = favorites.products[i]
                        prod.tags = arg.tags
                        Object.assign(draft, favorites)
                    })
                );

                //Fix item details with modified product
                const itemDetailsUpdate = queryApi.dispatch(
                    api.util.updateQueryData('getItemDetails', {id: arg.productId, catalog: arg.catalog}, (draft) => {
                        draft.tags = arg.tags;
                    })
                );

                try {
                    await queryApi.queryFulfilled
                } catch (error) {
                    console.log(error);
                    workspaceUpdate.undo()
                    searchResultsUpdate.undo()
                    favoritesUpdate.undo()
                    itemDetailsUpdate.undo()
                }
            },
        }),

        putUserTags: build.mutation<IActionResponse, {tags: string[], productId: string, catalog: string}>({
            query: (arg) => ({
                url: `catalog/${arg.catalog}/products/${arg.productId}/userTags`,
                method: 'PUT',
                body: arg.tags
            }),
            async onQueryStarted(arg, queryApi) {
                const state = queryApi.getState() as RootState;
                const workspace = state.settings?.selectedWorkspaceId ?? ""

                const criteria = state.search.criteria;
                const catalog = state.search.selectedCatalog;

                //Fix search results with modified product
                const searchResultsUpdate = queryApi.dispatch(api.util.updateQueryData('getSearchResults', {
                    catalog: catalog?.name,
                    criteria
                }, (draft) => {
                    const products = cloneDeep(draft.products);
                    const item = products.findIndex(a => a.id == arg.productId)
                    products[item].userTags = arg.tags;
                    Object.assign(draft, {...draft, products});
                }));

                let products: IWorkspaceItem[] = [];

                //Fix workspace with modified product
                const workspaceUpdate = queryApi.dispatch(
                    api.util.updateQueryData('getWorkspaceProducts', workspace, (draft) => {
                        products = cloneDeep(draft);
                        const i = products.findIndex(p => p.productId === arg.productId);
                        if (i === -1) return;
                        const prod = products[i];
                        if(prod.product) {
                            prod.product.userTags = arg.tags
                            Object.assign(draft, products)
                        }
                    })
                );

                let favorites: ISearchQueryResponse;

                //Fix favorites with modified product
                const favoritesUpdate = queryApi.dispatch(
                    api.util.updateQueryData('getFavoritesProducts', undefined, (draft) => {
                        favorites = cloneDeep(draft);
                        const i = favorites.products.findIndex(p => p.id === arg.productId);
                        if (i === -1) return;
                        const prod = favorites.products[i]
                        prod.userTags = arg.tags
                        Object.assign(draft, favorites)
                    })
                );

                //Fix item details with modified product
                const itemDetailsUpdate = queryApi.dispatch(
                    api.util.updateQueryData('getItemDetails', {id: arg.productId, catalog: arg.catalog}, (draft) => {
                        draft.userTags = arg.tags;
                    })
                );

                try {
                    await queryApi.queryFulfilled
                } catch (error) {
                    console.log(error);
                    workspaceUpdate.undo()
                    searchResultsUpdate.undo()
                    favoritesUpdate.undo()
                    itemDetailsUpdate.undo()
                }
            },
        }),
        setImage: build.mutation<IUploadFileResponse, { imageId: string, file: ArrayBuffer, imageType: string|null}>({
            query: (arg) => ({
                url: `files/product/images`,
                method: 'POST',
                body: {
                    file: ArrayBufferToBase64(arg.file),
                    fileName: `${arg.imageId}.png`,
                    imageType: arg.imageType ?? "Default"
                }
            })
        }),
        deleteProductImages: build.mutation<IActionResponse, {productId: string, imageIds: string[]}>({
            query: (arg) => ({
                url: `files/product/${arg.productId}/images`,
                method: 'DELETE',
                body:{
                    customImageIds: arg.imageIds
                }
            }),
        }),
        uploadImage: build.mutation<IUploadFileResponse, { imageId: string, file: ArrayBuffer, imageType: string|null}>({
            query: (arg) => ({
                url: 'files/images',
                method: 'POST',
                body: {
                    file: ArrayBufferToBase64(arg.file),
                    fileName: `${arg.imageId}.png`,
                    imageType: arg.imageType ?? 'Default',
                }
            })
        }),
        uploadStorefrontBannerImage: build.mutation<IUploadFileResponse, { file: ArrayBuffer, fileName: string }>({
            query: (arg) => ({
                url: 'storefront/storefronts/banner-image',
                method: 'POST',
                body: {
                    file: ArrayBufferToBase64(arg.file),
                    fileName: arg.fileName,
                }
            })
        }),
        getNotes: build.query<IGetNotesResponse, IProductReference>({
            query: (arg) => ({
                url: `catalog/${arg.catalog}/products/${arg.id}/notes`
            }),
            providesTags: (_results, _error, arg) =>
                [{type: PRODUCT_NOTES_TYPE, id: `${arg.catalog}-${arg.id}`}],
        }),
        putNotes: build.mutation<IActionResponse, { catalog: string, id: string, userNote: string | undefined, companyNote: string | undefined }>({
            query: (arg) => ({
                url: `catalog/${arg.catalog}/products/${arg.id}/notes`,
                method: 'PUT',
                body: {
                    userNote: arg.userNote,
                    companyNote: arg.companyNote
                }
            }),async onQueryStarted(arg, {dispatch, queryFulfilled}) {
                const patchResult = dispatch(
                    api.util.updateQueryData('getNotes', {
                        catalog: arg.catalog,
                        id: arg.id
                    }, (draft) => {
                        const newNotes = cloneDeep(draft);
                        newNotes.userNote.text = arg.userNote ?? '';
                        newNotes.companyNote.text = arg.companyNote ?? '';
                        Object.assign(draft, newNotes);
                    })
                );
                try {
                    await queryFulfilled
                } catch {
                    patchResult.undo();
                }
            }
        }),
        getInsights: build.query<IProductInsights, IProductReference>({
            query: (arg) => `catalog/${arg.catalog}/products/${arg.id}`,
        }),

        getCount: build.query<number, { catalog?: string, criteria: ISearchRequest }>({
            query: (arg) => ({
                url: `search/count`,
                method: 'POST',
                body: arg.criteria
            }),
            transformResponse: (result: ICountResponse) => result.count,
        }),
        getQuicksearch: build.query<IQuickSearchResponse, { catalog?: string, value: string | undefined }>({
            query: (arg) => `search/quicksearch?search=${arg.value}`,
        }),

        //endregion

        //region notifications
        getTasks: build.query<IAdaptiveCatalogTask[], {includeDismissed: boolean}>({
            query: (arg) => `tasks?includeDismissed=${arg.includeDismissed}`,
            transformResponse: (result: ICollectionResponse<IAdaptiveCatalogTask>) => result.items,
            providesTags: (result) => result
                ? [
                    ...result.map(t => ({type: TASKS_TYPE, id: t.id} as const)),
                    {type: TASKS_TYPE, id: LIST}
                ]
                : [{type: TASKS_TYPE, id: LIST}]
        }),
        dismissTask: build.mutation<void, IAdaptiveCatalogTask>({
            query: (arg) => ({
                url: `tasks/${arg.id}/dismiss`,
                method: 'POST',
            }),
            invalidatesTags: () => [{type: TASKS_TYPE, id: LIST}],
            async onQueryStarted(arg, {dispatch, queryFulfilled}) {
                const patchResult = dispatch(
                    api.util.updateQueryData('getTasks', {includeDismissed: false}, (draft) => {
                        const newTasks = cloneDeep(draft);
                        const i = newTasks.findIndex(i => i.id === arg.id);
                        if (i !== -1) newTasks[i].dismissed = true;
                        Object.assign(draft, newTasks);
                    })
                );
                const dismissedPatchResult = dispatch(
                    api.util.updateQueryData('getTasks', {includeDismissed: true}, (draft) => {
                        const newTasks = cloneDeep(draft);
                        const i = newTasks.findIndex(i => i.id === arg.id);
                        if (i !== -1) newTasks[i].dismissed = true;
                        Object.assign(draft, newTasks);
                    })
                );
                try {
                    await queryFulfilled
                } catch {
                    patchResult.undo();
                    dismissedPatchResult.undo();
                }
            }
        }),
        //endregion
        
        createSearchSession: build.mutation({
            query: () => ({
                url: `keyAuth/searchSession`,
                method: 'POST'
            }),
            async onQueryStarted(_arg, {dispatch, queryFulfilled}) {
                queryFulfilled.then((a) => dispatch(setSearchSession(a.data)))
            }
        }),
        //region Key Auth
        
        getSessionKey: build.mutation<IActionResponse, IGetSessionKeyRequest>({
            query: (arg) => ({
                url: `keyAuth/sessionkey`,
                method: 'POST',
                body: arg
            }),
        }),

        exchangeSupportLogin: build.mutation<ISupportLoginExchangeResponse, ISupportLoginExchangeRequest>({
            query: (arg) => ({
                url: `keyAuth/support/exchange`,
                method: 'POST',
                body: arg
            }),
        }),

        getSupportSessionStatus: build.query<ISupportSessionStatus, void>({
            query: () => 'keyAuth/support/session',
        }),

        endSupportSession: build.mutation<IActionResponse, void>({
            query: () => ({
                url: `keyAuth/support/session`,
                method: 'DELETE'
            }),
        }),

        // The support session's own notes. No cache tags: the notes panel is their only reader and writer, and it
        // writes each save back into this query's cache itself.
        getSupportSessionNotes: build.query<ISupportSessionNotes, void>({
            query: () => 'keyAuth/support/session/notes',
        }),

        saveSupportSessionNotes: build.mutation<ISupportSessionNotes, { text: string }>({
            query: (arg) => ({
                url: `keyAuth/support/session/notes`,
                method: 'PUT',
                body: arg
            }),
        }),

        getApiKeyTypes: build.query<IKeyAuthTypesResponse, void>({
            query: () => 'keyauth/apikeytypes'
        }),
        getApiKeys: build.query<IApiKey[], void>({
            query: () => 'keyauth/apikey',
            transformResponse: (result: IGetApiKeysResponse) => result.keys,
            providesTags:[API_KEYS]
        }),

        addApiKey: build.mutation<IGenerateApiKeyResponse, {request: IGenerateApiKeyRequest, username: string }>({
            query: (arg) => ({
                url: `keyauth/apikey`,
                method: 'POST',
                body: arg.request
            }),
            async onQueryStarted(arg, {dispatch, queryFulfilled}) {
                await queryFulfilled.then(a => {
                    dispatch(
                        api.util.updateQueryData('getApiKeys', undefined, (draft) => {
                            const newKey = {
                                id: a.data.id ?? "",
                                name: arg.request.name,
                                enabled: true,
                                keyType: arg.request.keyType,
                                username: arg.username ?? "",
                                // Same shape the API returns: a Date object here crashed the details dialog
                                // for a key just created (React can't render it), and isn't serializable state.
                                createDate: new Date().toISOString()
                            }
                            draft.push(newKey)
                        })
                    );
                    }
                )
            }
        }),

        disableApiKey: build.mutation<IActionResponse, string>({
            query: (arg) => ({
                url: `keyauth/apikey/${arg}/disable?`,
                method: 'POST',
            }),

            async onQueryStarted(arg, {dispatch, queryFulfilled}) {
                await queryFulfilled.then(() => {
                    dispatch(
                            api.util.updateQueryData('getApiKeys', undefined, (draft) => {
                                const updatedKeys = cloneDeep(draft);
                                const i = updatedKeys.findIndex(i => i.id === arg);
                                updatedKeys[i].enabled = false;
                                Object.assign(draft, updatedKeys);
                            })
                        );
                    }
                )
            }
        }),
        enableApiKey: build.mutation<IActionResponse, string>({
            query: (arg) => ({
                url: `keyauth/apikey/${arg}/enable?`,
                method: 'POST',
            }),
            async onQueryStarted(arg, {dispatch, queryFulfilled}) {
                await queryFulfilled.then(() => {
                    dispatch(
                            api.util.updateQueryData('getApiKeys', undefined, (draft) => {
                                const updatedKeys = cloneDeep(draft);
                                const i = updatedKeys.findIndex(i => i.id === arg);
                                updatedKeys[i].enabled = true;
                                Object.assign(draft, updatedKeys);
                            })
                        );
                    }
                )
            }

        }),
        deleteApiKey: build.mutation<IActionResponse, string>({
            query: (arg) => ({
                url: `keyauth/apikey/${arg}`,
                method: 'DELETE',
            }),
            async onQueryStarted(arg, {dispatch, queryFulfilled}) {
                await queryFulfilled.then(() => {
                        dispatch(
                            api.util.updateQueryData('getApiKeys', undefined, (draft) => {
                                const updatedKeys = cloneDeep(draft);
                                const i = updatedKeys.findIndex(i => i.id === arg);
                                draft.splice(i, 1)
                            })
                        );
                    }
                )
            }
        }),

        //endregion

        //region Reporting
        getSearchReport: build.query<ISearchReport, void>({
            query: () => '/reporting/search/usage'
        }),
        getMonthlyApiUsageReport: build.query<IApiUsageMonthlyReport, {year: number, month: number}>({
            query: (arg) => `/reporting/api/monthly/${arg.year}/${arg.month}`
        }),
        //endregion

        //region Permissions
        getPermissions: build.query<IGetPermissionsResponse, void>({
            query: () => 'settings/permissions'
        }),

        //region SubOrganization
        getSubOrganizations: build.query<ISubOrganization[], void>({
            query: () => 'settings/subOrganizations',
            providesTags: [SUB_ORGANIZATIONS],
            transformResponse: (result: ICollectionResponse<ISubOrganization>) => result.items,
        }),

        addSubOrganization: build.mutation<ISubOrganization, ICreateSubOrganizationRequest>({
            query: (arg) => ({
                url: `settings/subOrganizations`,
                method: 'POST',
                body: arg
            }),
            invalidatesTags: [SUB_ORGANIZATIONS],
        }),

        updateSubOrganization: build.mutation<ISubOrganization, {body: ICreateSubOrganizationRequest, id: string}>({
            query: (arg) => ({
                url: `settings/subOrganizations/${arg.id}`,
                method: 'PUT',
                body: arg.body
            }),
            invalidatesTags: [SUB_ORGANIZATIONS],
        }),
        //endregion

        //region Workspace Import
        uploadWorkspaceImportFile: build.mutation<IWorkspaceFileImportResponse, {file: IWorkspaceFileImportRequest, workspace: string}>({
            query: (arg) => ({
                url: `workspaces/${arg.workspace}/import/file`,
                method: 'POST',
                body: arg.file,
            })
        }),
        //endregion

        //region ML
        analyzeCustomerRequest: build.mutation<IActionResponse, {req: ICustomerRequestAnalysisRequest, workspace: string}>({
            query: (arg) => ({
                url: `workspaces/${arg.workspace}/ml/customerRequest/analyze`,
                method: 'POST',
                body: arg.req,
            })
        }),
        getCustomerAnalysis: build.query<ICustomerRequestAnalysisResponse, {id: string}>({
            query: (arg) => `ml/customerRequest/${arg.id}`,
        }),
        getCustomerAnalysisForWorkspace: build.query<ICollectionResponse<ICustomerRequestAnalysisOverview>, {workspace: string}>({
            query: (arg) => `workspaces/${arg.workspace}/ml/customerRequest`,
        }),
        deleteCustomerAnalysis: build.mutation<IActionResponse, {id: string}>({
            query: (arg) => ({
                url: `ml/customerRequest/${arg.id}`,
                method: 'DELETE',
            })
        }),
        thumbsUpCustomerAnalysis: build.mutation<IActionResponse, {id: string}>({
            query: (arg) => ({
                url: `ml/customerRequest/${arg.id}/rating/thumbsUp`,
                method: 'PUT',
            }),
            async onQueryStarted(arg, {dispatch, queryFulfilled}) {
                await queryFulfilled
                dispatch(
                    api.util.updateQueryData('getCustomerAnalysis', {id: arg.id} , (draft) => {
                        draft.rating = 'ThumbsUp';
                    })
                );
            }
        }),
        thumbsDownCustomerAnalysis: build.mutation<IActionResponse, {id: string}>({
            query: (arg) => ({
                url: `ml/customerRequest/${arg.id}/rating/thumbsDown`,
                method: 'PUT',
            }),
            async onQueryStarted(arg, {dispatch, queryFulfilled}) {
                await queryFulfilled
                dispatch(
                    api.util.updateQueryData('getCustomerAnalysis', {id: arg.id} , (draft) => {
                        draft.rating = 'ThumbsDown';
                    })
                );
            }
        }),
        clearCustomerAnalysisRating: build.mutation<IActionResponse, {id: string}>({
            query: (arg) => ({
                url: `ml/customerRequest/${arg.id}/rating`,
                method: 'DELETE',
            }),
            async onQueryStarted(arg, {dispatch, queryFulfilled}) {
                await queryFulfilled
                dispatch(
                    api.util.updateQueryData('getCustomerAnalysis', {id: arg.id} , (draft) => {
                        draft.rating = 'None';
                    })
                );
            }
        }),
        uploadCustomerRequestDocument: build.mutation<IActionResponse, { file: ArrayBuffer, fileName: string, workspace: string }>({
            query: (arg) => ({
                url: `workspaces/${arg.workspace}/ml/customerRequest/analyze/document`,
                method: 'POST',
                body: {
                    file: ArrayBufferToBase64(arg.file),
                    fileName: arg.fileName,
                }
            })
        }),
        runAnalysisExtension: build.mutation<IActionResponse, { extension: string, externalId: string }>({
            query: (arg) => ({
                url: `ml/customerRequest/import/extensions/${arg.extension}/run/${arg.externalId}`,
                method: 'POST',
            })
        }),
        getUserChats: build.query<ICollectionResponse<IUserChat>, void>({
            query: () => 'ml/chat/sessions',
            providesTags: (result) => result?.items ?
                [
                    ...result.items.map(c => ({type: ML_USER_CHAT_TYPE, id: c.id} as const)),
                    {type: ML_USER_CHAT_TYPE, id: LIST}
                ]
                : [{type: ML_USER_CHAT_TYPE, id: LIST}]
        }),
        getUserChat: build.query<IUserChat, string>({
            query: (arg) => `ml/chat/sessions/${arg}`,
            providesTags: (result) => [{type: ML_USER_CHAT_TYPE, id: result?.id}]
        }),
        createUserChat: build.mutation<IActionResponse, { request: IUserChatMessageRequest }>({
            query: (arg) => ({
                url: `ml/chat/sessions`,
                method: 'POST',
                body: arg.request,
            }),
            invalidatesTags: [{type: ML_USER_CHAT_TYPE, id: LIST}]
        }),
        addUserChatMessage: build.mutation<IActionResponse, { id: string, request: IUserChatMessageRequest }>({
            query: (arg) => ({
                url: `ml/chat/sessions/${arg.id}/messages`,
                method: 'POST',
                body: arg.request,
            }),
            invalidatesTags: (_r, _e, arg) => [{type: ML_USER_CHAT_TYPE, id: LIST}, {type: ML_USER_CHAT_TYPE, id: arg.id}]
        }),
        //endregion
        //REGION Custom Column Set
        putCustomColumnSet: build.mutation<IActionResponse, {columnSet: ICustomColumnSet}>({
            query: (arg) => ({
                url: `settings/customColumnSets`,
                method: 'PUT',
                body: arg.columnSet
            }),
            async onQueryStarted(arg, {dispatch}) {
                dispatch(
                    api.util.updateQueryData('getColumnSet', {columnType: arg.columnSet.columnType } , (draft) => {
                        if(draft != undefined) {
                            Object.assign(draft, arg.columnSet)
                        }
                    })
                );
            }
        }),
        getColumnSet: build.query<ICustomColumnSet, {columnType: string } >({
            query: (arg) => `settings/customColumnSets/${arg.columnType}`
        }),
        //endregion
        //region User Settings
        getUserSettings: build.query<IUserSettings, void>({
            query: () => 'settings/user/settings'
        }),
        patchUserSettings: build.mutation<IActionResponse, IUserSettingsUpdateRequest>({
            query: (arg) => ({
                url: 'settings/user/settings',
                method: 'PATCH',
                body: arg
            }),
            async onQueryStarted(arg, {dispatch}) {
                dispatch(
                    api.util.updateQueryData('getUserSettings', undefined, (draft) => {
                        Object.assign(draft, {...draft, ...arg})
                    })
                );
            }
        }),
        //endregion
        
        //REGION Notifications
        getNotifications: build.query<INotification, void>({
            query: () => `notifications`,
        }),
        dismissNotification: build.mutation<IActionResponse, {id: string} >({
            query: (arg) => ({
                url: `notifications/dismiss/${arg.id}`,
                method: 'PUT',
            })
        }),
        //endregion

        //REGION Grid Configurations

        getGridConfiguration: build.query<IGridConfiguration, {gridIdentifier: string, gridIdHint: string}>({
            query: (arg) => ({
                url:(`gridconfigurations/${arg.gridIdentifier}?gridIdHint=${arg.gridIdHint}`)
            })
        }),

        getGridAssignment: build.query<IGridAssignmentResponse, string>({
            query: (arg) => ({
                url:(`gridconfigurations/${arg}/assign`)
            })
        }),

        saveGridConfiguration: build.mutation<IActionResponse, {gridIdentifier: string, grid: IGridConfiguration}>({
            query: (arg) => ({
                url: `gridconfigurations`,
                method: 'POST',
                body: arg.grid
            }),
            async onQueryStarted(arg, {dispatch, queryFulfilled}){
                const finishedData = await queryFulfilled
                dispatch(
                    api.util.updateQueryData('getGridConfiguration', {gridIdentifier: arg.gridIdentifier, gridIdHint: arg.grid.id ?? ''}, draft => {
                        Object.assign(draft, arg.grid);
                    })
                );
                dispatch(
                    api.util.updateQueryData('getAvailableGridConfigurations', arg.gridIdentifier, draft => {
                        const copy = cloneDeep(draft)
                        const index = draft.findIndex(a => a.id === arg.grid.id)
                        if(index !== -1){
                            copy.splice(index, 1, arg.grid)
                            Object.assign(draft, copy)
                        }
                        else if(finishedData.data != undefined) {
                                arg.grid.id = finishedData.data.id
                                copy.splice(copy.length, 0, arg.grid)
                                Object.assign(draft, copy)
                        }
                    })
                );
            }
        }),

        saveGridAssignment: build.mutation<IActionResponse, {gridIdentifier: string, gridId: string}>({
            query: (arg) => ({
                url: `gridconfigurations/${arg.gridIdentifier}/assign/${arg.gridId}`,
                method: 'POST',
            }),
            onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
                const patchResult = dispatch(
                    api.util.updateQueryData('getGridAssignment', arg.gridIdentifier, draft => {
                        const copy = cloneDeep(draft)
                        copy.assignment = arg.gridId
                        Object.assign(draft, copy);
                    })
                );
                try {
                    await queryFulfilled;
                } catch {
                    patchResult.undo();
                }
            }

        }),

        getAvailableGridConfigurations: build.query<IGridConfiguration[], string>({
            query: (arg) => ({
                url: `gridconfigurations/${arg}/available`
            }),
            transformResponse: (result: ICollectionResponse<IGridConfiguration>) => result.items
        }),

        getSampleGridData: build.query<IGridSampleData[], string>({
            query: (arg) => ({
                url: `gridconfigurations/${arg}/sample`
            }),
            transformResponse: (result: ICollectionResponse<IGridSampleData>) => result.items
        }),
        //endregion

        //REGION CSV Export

        queueReport: build.mutation<IActionResponse, ICreateCsvRequest>({
            query: (arg) => ({
                url: 'files/reports',
                method: 'POST',
                body: arg
            })
        }),
        getReportGenerationStatus: build.query<IReportStatusLog, string>({
            query: (arg) => ({
                url: `files/reports/${arg}`
            })
        }),

        //endregion

        getVendors: build.query<ICollectionResponse<string>, string>({
            query: (arg) => `catalog/${arg}/products/vendors`
        }),
        getAllVendorSettings: build.query<ICollectionResponse<IVendorSettings>, void>({
            query: () => 'settings/vendors',
            keepUnusedDataFor: 600,
            providesTags: (res) => res?.items
                ? [{type: SETTINGS_VENDOR_SETTINGS, id: LIST},
                    ...res.items.map(v => ({type: SETTINGS_VENDOR_SETTINGS, id: v.sourceVendor.toLowerCase()} as const))
                ]
                : [{type: SETTINGS_VENDOR_SETTINGS, id: LIST}]
        }),
        getKnownVendors: build.query<ICollectionResponse<IKnownVendor>, void>({
            query: () => 'settings/vendors/known',
            keepUnusedDataFor: 600,
            providesTags: [{type: KNOWN_VENDORS, id: LIST}]
        }),
        getVendorSettings: build.query<IVendorSettings, string>({
            query: (arg) => `settings/vendors/${arg}`,
            keepUnusedDataFor: 600,
            providesTags: (_r, _e, arg) => [{type: SETTINGS_VENDOR_SETTINGS, id: arg.toLowerCase()}]
        }),
        putVendorSettings: build.mutation<IActionResponse, {vendor: IVendorSettings}>({
            query: (arg) => ({
                url: `settings/vendors/${arg.vendor.sourceVendor}`,
                method: 'PUT',
                body: arg.vendor
            }),
            invalidatesTags: (_r, _e, arg) => [{type: SETTINGS_VENDOR_SETTINGS, id: arg.vendor.sourceVendor.toLowerCase()}],
            async onQueryStarted(arg, {dispatch, queryFulfilled}) {
                await queryFulfilled.then(() => {
                    dispatch(
                        api.util.updateQueryData('getVendorSettings', arg.vendor.sourceVendor, (draft) => {
                            Object.assign(draft, arg.vendor)
                        })
                    );
                    dispatch(
                        api.util.updateQueryData('getAllVendorSettings', undefined, (draft) => {
                            const i = draft.items.findIndex(i => i.sourceVendor === arg.vendor.sourceVendor);
                            if (i !== -1) draft.items[i] = arg.vendor;
                            else draft.items.push(arg.vendor);
                        })
                    );
                })
            }
        }),
        deleteVendorSettings: build.mutation<IActionResponse, string>({
            query: (arg) => ({
                url: `settings/vendors/${arg}`,
                method: 'DELETE'
            }),
            invalidatesTags: (_r, _e, arg) => [{type: SETTINGS_VENDOR_SETTINGS, id: arg.toLowerCase()}],
            async onQueryStarted(arg, queryApi) {
                queryApi.dispatch(
                    api.util.updateQueryData('getAllVendorSettings', undefined, (draft) => {
                        const index = draft.items.findIndex((a) => a.sourceVendor === arg)
                        draft.items.splice(index, 1);
                    })
                )
            }
        }),
        getUserTour: build.query<IUserTour, string>({
            query: (arg) => ({
                url: `tours/user/${arg}`,
                method: 'GET'
            })
        }),
        dismissUserTour: build.mutation<IActionResponse, string>({
            query: (arg) => ({
                url: `tours/user/${arg}/dismiss`,
                method: 'POST'
            }),
            onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
                const patchResult = dispatch(
                    api.util.updateQueryData('getUserTour', arg, draft => {
                        draft.dismissed = true;
                    })
                );
                try {
                    await queryFulfilled;
                } catch {
                    patchResult.undo();
                }
            }
        }),
        completeUserTour: build.mutation<IActionResponse, string>({
            query: (arg) => ({
                url: `tours/user/${arg}/complete`,
                method: 'POST'
            }),
            onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
                const patchResult = dispatch(
                    api.util.updateQueryData('getUserTour', arg, draft => {
                        draft.completed = true;
                    })
                );
                try {
                    await queryFulfilled;
                } catch {
                    patchResult.undo();
                }
            }
        }),
        viewUserTour: build.mutation<IActionResponse, string>({
            query: (arg) => ({
                url: `tours/user/${arg}/view`,
                method: 'POST'
            }),
            onQueryStarted: async (arg, {dispatch, queryFulfilled}) => {
                const patchResult = dispatch(
                    api.util.updateQueryData('getUserTour', arg, draft => {
                        draft.seen = true;
                        draft.viewCount = (draft.viewCount ?? 0) + 1;
                    })
                );
                try {
                    await queryFulfilled;
                } catch {
                    patchResult.undo();
                }
            }
        }),
        postFeatureRequest: build.mutation<IActionResponse, IFeatureRequest>({
            query: (arg) => ({
                url: 'featureRequests/feature',
                method: 'POST',
                body: arg
            })
        }),

        //region Configurator
        postSearchConfigurationProducts: build.query<ICollectionResponse<IConfiguratorProductSearchView>, ISearchRequest>({
            query: (arg) => ({
                url: 'configurator/products/search',
                method: 'POST',
                body: arg
            }),
        }),
        getConfigurationProduct: build.query<IConfigurationProduct, string>({
            query: (arg) => ({
                url: `configurator/products/${arg}`,
                method: 'GET'
            })
        }),
        postResolveConfigurationProduct: build.mutation<IConfigurationResolutionResponse, {id: string, req: IConfigurationResolutionRequest}>({
            query: (arg) => ({
                url: `configurator/products/${arg.id}/resolve`,
                method: 'POST',
                body: arg.req
            })
        })
        //endregion

    })
});


export default api;

export const {
    useGetCatalogsQuery,
    useAddCatalogMutation,
    useUpdateCatalogMutation,
    useGetTaxCodesQuery,
    useAddUpdateTaxCodeMutation,
    useDeleteTaxCodeMutation,
    useGetColumnsQuery,
    useSetSearchColumnsMutation,
    useSetWorkspaceColumnsMutation,
    useGetWorkspacesQuery,
    useLazyGetWorkspacesQuery,
    useGetFavoritesQuery,
    useGetFavoritesProductsQuery,
    useGetSearchResultsQuery,
    usePutWorkspaceMutation,
    useAddWorkspaceMutation,
    useDeleteCatalogMutation,
    useRemoveWorkspaceMutation,
    useSetUserFavoriteMutation,
    useRemoveUserFavoriteMutation,
    useSetCompanyFavoriteMutation,
    useRemoveCompanyFavoriteMutation,
    useSetSelectedWorkspaceMutation,
    useSetWorkspaceExtensionFieldMutation,
    useGetWorkspaceQuery,
    useClearWorkspaceCacheMutation,
    useDeleteInstalledExtensionMutation,
    useDisableInstalledExtensionMutation,
    useEnableInstalledExtensionMutation,
    useGetAvailableExtensionQuery,
    useGetAvailableExtensionsQuery,
    useGetInstalledExtensionLogsQuery,
    useGetExtensionActivitiesQuery,
    useGetUnmatchedExtensionProductsQuery,
    useGetProductPurchaseHistoryQuery,
    usePostConfirmExtensionProductMatchMutation,
    usePostCreateExtensionProductFromUnmatchedMutation,
    useGetInstalledExtensionsQuery,
    useInstallExtensionMutation,
    usePutInstalledExtensionMutation,
    useGetExtensionLibraryQuery,
    usePostExtensionLibraryFileMutation,
    usePostDisableExtensionLibraryFileMutation,
    usePostEnableExtensionLibraryFileMutation,
    useGetWorkspaceProductsQuery,
    useLazyGetImportSampleQuery,
    useGetWorkspaceMetadataFieldQuery,
    useGetWorkspaceMetadataQuery,
    useGetWorkspaceRecommendationsQuery,
    useClearWorkspaceRecommendationsMutation,
    useUploadRecommendationFileMutation,
    useGetExportExtensionOptionsQuery,
    useGetItemExtensionFieldsQuery,
    usePutItemExtensionFieldMutation,
    useGetExtensionPotentialMatchesQuery,
    useRunExportExtensionMutation,
    useRunImportExtensionMutation,
    useRunImportExtensionsForFolioMutation,
    useGetItemDetailsQuery,
    useLazyGetItemDetailsQuery,
    useRunRealtimeExtensionMutation,
    useRunRealtimeSearchExtensionMutation,
    useClearExtensionsMutation,
    usePostProductMutation,
    usePutProductMutation,
    useResetProductToCatalogMutation,
    useSetImageMutation,
    useGetNotesQuery,
    usePutNotesMutation,
    useGetMultipleItemDetailsQuery,
    useGetProductLinkedItemsQuery,
    useGetLinkedItemTypesQuery,
    useSaveProductLinkedItemsMutation,
    useDeleteProductLinkedItemMutation,
    useBulkListOnStorefrontMutation,
    useLazyGetSearchResultsQuery,
    useGetMetadataQuery,
    useGetTasksQuery,
    useDismissTaskMutation,
    useValidateExtensionSettingsMutation,
    useValidateInstalledExtensionMutation,
    useSimpleValidateInstalledExtensionMutation,
    useGetSessionKeyMutation,
    useExchangeSupportLoginMutation,
    useGetSupportSessionStatusQuery,
    useEndSupportSessionMutation,
    useGetSupportSessionNotesQuery,
    useSaveSupportSessionNotesMutation,
    useGetSearchReportQuery,
    useGetMonthlyApiUsageReportQuery,
    useGetApiKeysQuery,
    useDisableApiKeyMutation,
    useEnableApiKeyMutation,
    useAddApiKeyMutation,
    useDeleteApiKeyMutation,
    useGetCountQuery,
    useGetQuicksearchQuery,
    useGetSearchFacetPreviewQuery,
    useLazyGetEmbeddedSearchResultsQuery,
    useGetSearchMetadataQuery,
    useGetSearchSuggestionsQuery,
    useLazyGetQuicksearchQuery,
    useDeleteProductImagesMutation,
    useCreateSearchSessionMutation,
    useUpdateProductVisitMutation,
    useGetProductTagsQuery,
    usePutTagsMutation,
    usePutUserTagsMutation,
    useGetTemplateWorkspacesQuery,
    useGetExtensionInstallOptionsQuery,
    useGetWorkspaceExtensionMetadataQuery,
    useGetSubOrganizationsQuery,
    useAddSubOrganizationMutation,
    useUpdateSubOrganizationMutation,
    useAddWorkspaceWithTemplateDefaultsMutation,
    useGetCompaniesQuery,
    useLazyGetCompaniesQuery,
    useSearchCompanyRefsQuery,
    useGetCompanyQuery,
    useGetCompanySuggestionsQuery,
    useGetWorkspaceProductSuggestionsQuery,
    useGetBundleProductSuggestionsQuery,
    useGetProductSearchPreviewQuery,
    usePutCompanyMutation,
    useDisableCompanyMutation,
    useEnableCompanyMutation,
    useDeleteCompanyMutation,
    useLazyGetCompanyQuery,
    usePostGenerateContactsFromCompaniesMutation,
    useGetContactsQuery,
    useLazyGetContactsQuery,
    useGetContactByIdQuery,
    useLazyGetContactByIdQuery,
    useGetContactsForCompanyQuery,
    useSaveContactMutation,
    useDisableContactMutation,
    useEnableContactMutation,
    useDeleteContactMutation,
    useGetLocationsForCompanyQuery,
    useCreateLocationMutation,
    useUpdateLocationMutation,
    useDeleteLocationMutation,
    useSetCompanyDefaultLocationMutation,
    useLazyGetWorkspaceQuery,
    useUploadImageMutation,
    useGetApiKeyTypesQuery,
    useGetExtensionCompanyQuery,
    useLazyGetExtensionCompanyQuery,
    useLazyGetImportCompanyExtensionOptionsQuery,
    useRunDocumentExtensionMutation,
    useGetInstalledExtensionQuery,
    useUploadWorkspaceImportFileMutation,
    usePostSearchTableRowQuery,
    useLazyGetExportExtensionOptionsQuery,
    useLazyGetExportExtensionSuggestionsQuery,
    useLazyGetExtensionFieldMetadataQuery,
    useLazyGetExtensionOptionsBatchQuery,
    useRunDirectImportExtensionMutation,
    useLazyGetDirectImportPreviewQuery,
    useAnalyzeCustomerRequestMutation,
    useGetCustomerAnalysisQuery,
    useGetCustomerAnalysisForWorkspaceQuery,
    useDeleteCustomerAnalysisMutation,
    useThumbsUpCustomerAnalysisMutation,
    useThumbsDownCustomerAnalysisMutation,
    useClearCustomerAnalysisRatingMutation,
    useUploadCustomerRequestDocumentMutation,
    useRunAnalysisExtensionMutation,
    useGetUserChatsQuery,
    useGetUserChatQuery,
    useCreateUserChatMutation,
    useAddUserChatMessageMutation,
    useConfirmExtensionPotentialMatchMutation,
    usePutCustomColumnSetMutation,
    useGetColumnSetQuery,
    useGetDirectImportPreviewQuery,
    useGetUserSettingsQuery,
    usePatchUserSettingsMutation,
    useGetExtensionFolioQuery,
    useGetCrmFolioCandidatesQuery,
    useQuickSetupExtensionFolioMutation,
    useSetCrmFolioCapabilitiesMutation,
    useCreateCrmTestOpportunityMutation,
    useEnsurePsaProposalMutation,
    useEnsurePsaFieldInferenceMutation,
    useGetPsaProposalQuery,
    useRecordPsaProposalDecisionMutation,
    usePutExtensionFolioMutation,
    usePatchExtensionFolioCommonFieldsMutation,
    useGetNotificationsQuery,
    useDismissNotificationMutation,
    useValidateExtensionFolioMutation,
    useSimpleValidateExtensionFolioMutation,
    useGetStorefrontSubExtensionReferencesQuery,
    useGetSubExtensionFolioSubExtensionReferencesQuery,
    useEnableFolioSubExtensionMutation,
    useLazyGetExportExtensionOptionFriendlyNameQuery,
    useGetVendorsQuery,
    useGetGridConfigurationQuery,
    useSaveGridConfigurationMutation,
    useSaveGridAssignmentMutation,
    useGetAvailableGridConfigurationsQuery,
    useGetGridAssignmentQuery,
    useGetVendorSettingsQuery,
    usePutVendorSettingsMutation,
    useDeleteVendorSettingsMutation,
    useGetAllVendorSettingsQuery,
    useGetKnownVendorsQuery,
    useGetSampleGridDataQuery,
    useGetReportGenerationStatusQuery,
    useQueueReportMutation,
    useGetUserTourQuery,
    useDismissUserTourMutation,
    useCompleteUserTourMutation,
    useViewUserTourMutation,
    useGetRecentWorkspaceRefsQuery,
    useSearchWorkspaceRefsQuery,
    useGetWorkspaceSearchViewsQuery,
    usePostFeatureRequestMutation,
    useActivateWorkspaceMutation,
    useLazyPostSearchConfigurationProductsQuery,
    useGetConfigurationProductQuery,
    usePostResolveConfigurationProductMutation,
    useUploadStorefrontBannerImageMutation
} = api;
